var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1536,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 1024,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C73.64504339 -0.12099405 73.64504339 -0.12099405 104.5 -0.14648438 C111.56119813 -0.15235708 118.62239606 -0.15841827 125.68359375 -0.16479492 C127.01091558 -0.16598179 127.01091558 -0.16598179 128.36505198 -0.16719264 C142.60966901 -0.18020419 156.85424933 -0.20383537 171.09884466 -0.23145839 C185.74164929 -0.25961462 200.38443484 -0.27619774 215.02726543 -0.28226548 C224.04661675 -0.28636085 233.06586432 -0.29924685 242.08518367 -0.3237494 C248.2885996 -0.33973308 254.49196271 -0.34437214 260.69539769 -0.34050413 C264.26266347 -0.33860199 267.82974928 -0.34130246 271.39698219 -0.35761642 C308.16543088 -0.51715745 341.44769529 3.56264831 369 29.80859375 C376.39695136 37.2017518 381.30999428 45.71910994 386 55 C386.64582031 56.23363281 386.64582031 56.23363281 387.3046875 57.4921875 C396.91624949 77.23686911 397.51979439 101.32043238 397.39111328 122.81347656 C397.37500768 125.99848214 397.39108751 129.18221944 397.41015625 132.3671875 C397.42862415 150.81901246 396.21903922 169.48270624 390 187 C389.76297363 187.66837891 389.52594727 188.33675781 389.28173828 189.02539062 C380.36746476 213.62498033 362.92723664 233.60744742 339.125 244.8828125 C323.65882105 251.82681121 306.83133701 255.41343954 290 257 C289.14006345 257.08245185 288.2801269 257.1649037 287.39413166 257.24985409 C278.13409704 258.05659704 268.92788297 258.13530795 259.64331055 258.11352539 C257.93698122 258.11324268 256.23065177 258.11340288 254.52432251 258.1139679 C249.93225271 258.11425261 245.34020949 258.10840889 240.74814582 258.10139394 C235.93421552 258.09510583 231.12028448 258.09455231 226.30635071 258.09336853 C217.20841583 258.09027122 208.11049308 258.08207955 199.01256353 258.07201904 C188.64728559 258.06080801 178.28200706 258.05533492 167.91672456 258.05032361 C146.61114296 258.03989547 125.30557225 258.02232725 104 258 C104.0199855 259.19967911 104.03997101 260.39935822 104.06056213 261.63539124 C104.24312767 272.94964854 104.37797763 284.2636065 104.46630955 295.57900333 C104.51325003 301.39631163 104.5769001 307.21242957 104.67895508 313.02905273 C104.77685717 318.64422201 104.83058126 324.25824767 104.85389519 329.87420464 C104.87050541 332.01494794 104.90294357 334.15562967 104.95157051 336.29588509 C105.31784135 353.08702772 105.31784135 353.08702772 102.07313538 357.79702759 C99.77472701 359.60439971 97.64496379 360.78110558 95 362 C93.6766962 363.01159453 92.37599634 364.05434371 91.11328125 365.140625 C90.18044312 365.90282349 90.18044312 365.90282349 89.22875977 366.68041992 C88.59639404 367.19838135 87.96402832 367.71634277 87.3125 368.25 C81.36090861 373.1141927 75.3557017 377.899386 69.25317383 382.57324219 C66.16134698 384.878682 66.16134698 384.878682 64 388 C62.92298828 388.64388672 62.92298828 388.64388672 61.82421875 389.30078125 C58.52570827 391.28536225 55.70769265 393.6729123 52.8125 396.1875 C51.65584487 397.17943228 50.49828469 398.17031013 49.33984375 399.16015625 C48.4888208 399.8874292 48.4888208 399.8874292 47.62060547 400.62939453 C44.61172816 403.1741124 41.52001902 405.6131129 38.43359375 408.0625 C34.4928555 411.19990959 30.6019832 414.3975973 26.71044922 417.59570312 C24.68499451 419.25862283 22.65680315 420.91818448 20.62890625 422.578125 C19.08584333 423.84363519 17.54287461 425.10926024 16 426.375 C15.25741943 426.98230957 14.51483887 427.58961914 13.74975586 428.21533203 C13.04858643 428.79138184 12.34741699 429.36743164 11.625 429.9609375 C10.99851562 430.47446777 10.37203125 430.98799805 9.7265625 431.51708984 C7.96655499 432.97750403 7.96655499 432.97750403 6.3984375 434.68994141 C5 436 5 436 3 436 C3 436.66 3 437.32 3 438 C2.01 438 1.02 438 0 438 C-2.97793444 409.73849412 -4.95122183 381.45894643 -6.0625 353.0625 C-6.10429618 352.02166213 -6.14609237 350.98082425 -6.1891551 349.90844584 C-8.11910254 300.42101246 -8.78743019 255.35425008 26.20533341 217.15680224 C33.11335487 209.7840592 40.54032842 203.03022255 48.1875 196.4375 C48.76212903 195.94008128 49.33675807 195.44266255 49.92880011 194.93017054 C62.82083945 183.79975007 76.12242847 173.32691483 90.2220602 163.75482273 C95.33916333 160.28889165 95.33916333 160.28889165 99.90449524 156.15101624 C102 154 102 154 105 153 C105.02783516 155.20825618 105.04675802 157.4166245 105.0625 159.625 C105.07410156 160.85476563 105.08570313 162.08453125 105.09765625 163.3515625 C105.06914698 167.34581812 104.78709048 171.3075528 104.49389648 175.29052734 C104.40196518 176.54795746 104.31003387 177.80538757 104.21531677 179.10092163 C104.14426224 180.05761749 104.0732077 181.01431335 104 182 C125.20251645 181.91582435 146.40495816 181.82059146 167.60736656 181.71247292 C177.45372364 181.66251601 187.30007309 181.61607231 197.14648438 181.578125 C205.73635654 181.54501113 214.32616641 181.5050755 222.91596949 181.45720994 C227.45715369 181.43213608 231.99829759 181.41030033 236.53953171 181.39665604 C240.82903486 181.38365971 245.1183984 181.36142383 249.40782356 181.33261681 C250.967653 181.32367616 252.52750482 181.31788322 254.08735847 181.31578636 C262.3390184 181.30272766 270.47516717 180.97994793 278.68374634 180.09725952 C279.42363151 180.01896585 280.16351668 179.94067218 280.92582262 179.86000597 C292.05052093 178.55150956 301.55406459 174.56282572 309 166 C319.90219417 150.47682505 320.51345903 132.10612723 317.71875 113.8125 C315.61061768 102.63023294 311.21890501 93.54541194 301.875 86.6875 C292.26463445 80.95946755 283.23200017 79.74084168 272.2487793 79.41601562 C271.07662967 79.37743187 269.90448004 79.33884811 268.69681072 79.29909515 C244.38986578 78.56332011 220.0577396 78.62299357 195.74193287 78.55518341 C185.95514509 78.52744263 176.16906709 78.47610421 166.38257486 78.39470911 C159.4375967 78.33892684 152.49281232 78.30995403 145.54761809 78.3007102 C141.42149878 78.29447659 137.29622951 78.2765535 133.17035866 78.22932434 C129.30785571 78.18561322 125.44666797 78.17518165 121.58395958 78.18995285 C120.17302789 78.18962507 118.76203827 78.17741627 117.35133362 78.15210342 C108.12205463 77.94899878 108.12205463 77.94899878 100.32484436 82.32887268 C99.18877312 83.52682672 98.07911829 84.75049791 97 86 C95.7969971 87.19010264 94.58771035 88.37391897 93.36962891 89.54858398 C92.1528781 90.77872258 90.93858668 92.01129787 89.7265625 93.24609375 C88.39465814 94.5906205 87.06262328 95.93501799 85.73046875 97.27929688 C83.66136069 99.37339655 81.59390932 101.46908677 79.52880859 103.56713867 C77.51569682 105.61026514 75.49656228 107.64728047 73.4765625 109.68359375 C72.85576813 110.31784775 72.23497375 110.95210175 71.59536743 111.60557556 C70.1010939 113.10863494 68.55510291 114.55996673 67 116 C66.34 116 65.68 116 65 116 C64.7628125 116.56170898 64.525625 117.12341797 64.28125 117.70214844 C62.70680643 120.52582658 60.78315455 122.47614842 58.5 124.765625 C57.613125 125.65507812 56.72625 126.54453125 55.8125 127.4609375 C54.884375 128.38132812 53.95625 129.30171875 53 130.25 C52.071875 131.18585938 51.14375 132.12171875 50.1875 133.0859375 C49.300625 133.97023438 48.41375 134.85453125 47.5 135.765625 C46.27796875 136.98427246 46.27796875 136.98427246 45.03125 138.22753906 C43 140 43 140 41 140 C40.79375 140.53109375 40.5875 141.0621875 40.375 141.609375 C38.42038808 145.00773436 35.77876283 147.51055928 33 150.25 C32.4534375 150.80429687 31.906875 151.35859375 31.34375 151.9296875 C27.2533867 156 27.2533867 156 25 156 C24.79375 156.556875 24.5875 157.11375 24.375 157.6875 C22.85141907 160.24988611 21.01508071 161.69371939 18.69921875 163.52734375 C16.81396229 165.16123268 15.24611944 166.91686605 13.625 168.8125 C9.98187115 173.07228318 6.24693314 177.32908768 2 181 C1.34 181 0.68 181 0 181 C0 121.27 0 61.54 0 0 Z ",
    fill: "#FBA116",
    transform: "translate(560,300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.8125 4.875 C-2.534375 5.57625 -3.25625 6.2775 -4 7 C-4.45375 7.804375 -4.9075 8.60875 -5.375 9.4375 C-7.41160362 12.64906724 -10.04580818 14.6882715 -13 17 C-19.00277515 21.95286011 -24.46412758 27.34751819 -29.9375 32.875 C-30.81212891 33.75414062 -31.68675781 34.63328125 -32.58789062 35.5390625 C-34.72757048 37.6904346 -36.86486597 39.84411792 -39 42 C-39 39 -39 39 -37.51940918 37.15864563 C-36.82657837 36.47247665 -36.13374756 35.78630768 -35.41992188 35.0793457 C-34.63911255 34.29876297 -33.85830322 33.51818024 -33.05383301 32.71394348 C-32.20075562 31.87634995 -31.34767822 31.03875641 -30.46875 30.17578125 C-29.60310425 29.31438034 -28.7374585 28.45297943 -27.84558105 27.56547546 C-25.07065947 24.80738835 -22.28550377 22.05989543 -19.5 19.3125 C-17.62041202 17.4479526 -15.74149674 15.58272681 -13.86328125 13.71679688 C-9.2499735 9.13662174 -4.62821377 4.56510957 0 0 Z ",
    fill: "#F6A831",
    transform: "translate(602,514)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.8125 4.875 C-2.534375 5.57625 -3.25625 6.2775 -4 7 C-4.45375 7.804375 -4.9075 8.60875 -5.375 9.4375 C-7.47561787 12.75001279 -9.91050949 14.59706294 -13 17 C-13 13 -13 13 -11.80664062 11.35253906 C-11.26201172 10.82885742 -10.71738281 10.30517578 -10.15625 9.765625 C-9.56972656 9.19199219 -8.98320313 8.61835937 -8.37890625 8.02734375 C-7.75886719 7.44082031 -7.13882813 6.85429688 -6.5 6.25 C-5.87996094 5.64800781 -5.25992188 5.04601562 -4.62109375 4.42578125 C-3.08955179 2.94136366 -1.54590226 1.46945655 0 0 Z ",
    fill: "#FAA624",
    transform: "translate(602,514)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.11381955 6.76594019 0.88021369 13.28837062 0 20 C-0.33 20 -0.66 20 -1 20 C-2.76110006 13.17573725 -2.68507432 6.54486865 0 0 Z ",
    fill: "#F8A521",
    transform: "translate(956,440)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.39644592 3.85025879 0.23227397 6.86101159 -1.5625 10.3125 C-2.01753906 11.19550781 -2.47257813 12.07851563 -2.94140625 12.98828125 C-3.29074219 13.65214844 -3.64007812 14.31601562 -4 15 C-5.26426661 11.20720018 -4.40145184 9.65934648 -3 6 C-2.67 5.34 -2.34 4.68 -2 4 C-1.34 4 -0.68 4 0 4 C-0.33 3.01 -0.66 2.02 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F8A425",
    transform: "translate(946,490)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C-3.0022779 11.66742597 -3.0022779 11.66742597 -7 13 C-5.54331217 10.03216871 -3.98767914 7.13584687 -2.375 4.25 C-1.92898438 3.45078125 -1.48296875 2.6515625 -1.0234375 1.828125 C-0.68570313 1.22484375 -0.34796875 0.6215625 0 0 Z ",
    fill: "#FAA621",
    transform: "translate(875,456)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.49828872 3.88235819 0.43110582 6.43449288 -0.9375 10.25 C-1.31777344 11.32765625 -1.69804688 12.4053125 -2.08984375 13.515625 C-2.39019531 14.33546875 -2.69054687 15.1553125 -3 16 C-4.0546875 14.203125 -4.0546875 14.203125 -5 12 C-4.125 8.75 -4.125 8.75 -3 6 C-2.34 6 -1.68 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z ",
    fill: "#F6A527",
    transform: "translate(952,474)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.67 1.32 3.34 2.64 3 4 C2.34 4 1.68 4 1 4 C1 4.66 1 5.32 1 6 C0.01 5.67 -0.98 5.34 -2 5 C-1.34 5 -0.68 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4A528",
    transform: "translate(562,732)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C-0.96 3.98 -0.96 3.98 -5 6 C-4.67 4.68 -4.34 3.36 -4 2 C-3.01 2.33 -2.02 2.66 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#F8A423",
    transform: "translate(905,538)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.42655063 2.86724686 1.1385485 3.8614515 -1 6 C-1.99 5.67 -2.98 5.34 -4 5 C-2.71937515 3.2925002 -1.38232443 1.62626404 0 0 Z ",
    fill: "#FAA924",
    transform: "translate(663,453)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.55780196 0.60990891 6.6828589 1.5783681 10 3 C10 3.33 10 3.66 10 4 C7.25 4.25 7.25 4.25 4 4 C1.625 2 1.625 2 0 0 Z ",
    fill: "#F9A824",
    transform: "translate(893,308)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2 4 C0.35 4.33 -1.3 4.66 -3 5 C-2.67 4.34 -2.34 3.68 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#929492",
    transform: "translate(998,818)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.34 2.32 0.68 3.64 0 5 C0 4.34 0 3.68 0 3 C-0.66 2.67 -1.32 2.34 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9D9E9F",
    transform: "translate(1044,979)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 5.34 0.34 4.68 0 4 C-0.66 3.67 -1.32 3.34 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#999C9C",
    transform: "translate(1044,922)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.01 4.495 1.01 4.495 0 5 C0 4.34 0 3.68 0 3 C-0.66 2.67 -1.32 2.34 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949696",
    transform: "translate(1044,59)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C1.01 3.495 1.01 3.495 0 4 C-0.66 3.34 -1.32 2.68 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#958E82",
    transform: "translate(1044,659)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C1.67 3.66 1.34 4.32 1 5 C0.34 4.67 -0.32 4.34 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#A69070",
    transform: "translate(1044,283)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.01 4.495 1.01 4.495 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#959898",
    transform: "translate(1044,35)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 1.34 1.36 0.68 0 0 Z ",
    fill: "#9B9E9E",
    transform: "translate(1042,957)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 1.34 1.36 0.68 0 0 Z ",
    fill: "#989A9A",
    transform: "translate(1042,901)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.34 1.66 2.68 2.32 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#959897",
    transform: "translate(1042,861)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 1.34 1.36 0.68 0 0 Z ",
    fill: "#91928D",
    transform: "translate(1042,749)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.34 1.66 2.68 2.32 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#92918C",
    transform: "translate(1042,733)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.34 1.66 2.68 2.32 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#938F86",
    transform: "translate(1042,685)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C1.01 3 0.02 3 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#9D8F7B",
    transform: "translate(1044,243)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.34 1.66 2.68 2.32 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#979A9A",
    transform: "translate(1042,21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 1.34 1.36 0.68 0 0 Z ",
    fill: "#989A9B",
    transform: "translate(1042,13)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#9EA0A0",
    transform: "translate(1042,1021)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#9D9F9F",
    transform: "translate(1042,989)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#979A9A",
    transform: "translate(1042,893)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#A8906D",
    transform: "translate(1043,541)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.99 2.34 1.98 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#AD926A",
    transform: "translate(1042,509)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#929492",
    transform: "translate(1042,93)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#929493",
    transform: "translate(1042,85)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#929594",
    transform: "translate(1042,77)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2.66 -0.32 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#939594",
    transform: "translate(997,56)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#969999",
    transform: "translate(1042,29)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#9C9F9F",
    transform: "translate(1045,973)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#9B9D9D",
    transform: "translate(1045,948)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#9A9C9D",
    transform: "translate(998,938)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.01 1.67 -0.98 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#9B9D9E",
    transform: "translate(1092,930)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#999C9B",
    transform: "translate(1042,909)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#97999A",
    transform: "translate(998,898)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9EA1A1",
    transform: "translate(85,853)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#90928F",
    transform: "translate(997,792)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#929492",
    transform: "translate(1045,789)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#929491",
    transform: "translate(1045,781)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#928C80",
    transform: "translate(947,733)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#939391",
    transform: "translate(1091,730)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#91908A",
    transform: "translate(1044,715)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9DA09E",
    transform: "translate(85,693)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#968C7C",
    transform: "translate(996,673)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 2.495 1.01 2.495 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#A38D6E",
    transform: "translate(998,610)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9EA09F",
    transform: "translate(85,589)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA19F",
    transform: "translate(85,541)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A9906C",
    transform: "translate(1044,533)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA0A0",
    transform: "translate(85,533)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#AD9169",
    transform: "translate(1044,500)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,477)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA1A1",
    transform: "translate(85,397)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,365)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#B19367",
    transform: "translate(1045,357)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#AA926D",
    transform: "translate(1042,293)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9FA0A0",
    transform: "translate(85,285)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#9EA1A1",
    transform: "translate(85,213)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#949695",
    transform: "translate(1043,69)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949796",
    transform: "translate(1044,53)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9C9F9F",
    transform: "translate(948,1013)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9C9F9F",
    transform: "translate(948,1005)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9D9F9F",
    transform: "translate(996,997)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9C9F9F",
    transform: "translate(948,997)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9A9D9D",
    transform: "translate(948,965)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#999D9C",
    transform: "translate(948,957)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#979B9B",
    transform: "translate(948,933)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9A9B9C",
    transform: "translate(995,925)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#979A9A",
    transform: "translate(948,925)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#979999",
    transform: "translate(948,917)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#959899",
    transform: "translate(948,901)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#999B9C",
    transform: "translate(1090,891)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949796",
    transform: "translate(948,885)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#939696",
    transform: "translate(948,877)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA1A1",
    transform: "translate(85,869)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929494",
    transform: "translate(948,861)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949697",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929696",
    transform: "translate(998,850)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#979999",
    transform: "translate(1093,840)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949796",
    transform: "translate(1044,838)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#909391",
    transform: "translate(948,837)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#90928F",
    transform: "translate(948,829)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929494",
    transform: "translate(998,826)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#939695",
    transform: "translate(1045,821)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA2A1",
    transform: "translate(85,821)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F908C",
    transform: "translate(948,805)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#929593",
    transform: "translate(1045,797)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#908F8B",
    transform: "translate(948,797)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8F8A",
    transform: "translate(948,789)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#91918E",
    transform: "translate(995,781)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8E88",
    transform: "translate(948,781)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,781)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#919491",
    transform: "translate(1045,773)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8E87",
    transform: "translate(948,773)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8D86",
    transform: "translate(948,765)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#908C83",
    transform: "translate(948,749)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#918F89",
    transform: "translate(995,749)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#908C81",
    transform: "translate(948,741)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#918B7E",
    transform: "translate(948,725)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#938B7B",
    transform: "translate(948,717)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E84",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#948B7A",
    transform: "translate(948,709)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D83",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#928F87",
    transform: "translate(1045,701)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#968A78",
    transform: "translate(948,701)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D81",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9EA09F",
    transform: "translate(85,685)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8C74",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#968F87",
    transform: "translate(1090,627)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8C72",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#9C8E79",
    transform: "translate(1044,614)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#BB9154",
    transform: "translate(948,589)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28D72",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD8F64",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#A38F71",
    transform: "translate(1045,573)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9EA19F",
    transform: "translate(85,573)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA19F",
    transform: "translate(85,557)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949290",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA09F",
    transform: "translate(85,525)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49653",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49176",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,277)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9EA1A0",
    transform: "translate(85,269)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6906F",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#998F7F",
    transform: "translate(1044,222)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8F79",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#968F81",
    transform: "translate(1045,213)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A18E70",
    transform: "translate(948,213)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7B",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F83",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#938C80",
    transform: "translate(948,157)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#918D84",
    transform: "translate(948,141)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908D",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8E89",
    transform: "translate(948,117)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F8F8C",
    transform: "translate(948,101)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#91918F",
    transform: "translate(995,101)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F908D",
    transform: "translate(948,93)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#8F918F",
    transform: "translate(948,85)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929493",
    transform: "translate(996,69)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#909290",
    transform: "translate(948,69)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919493",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#919391",
    transform: "translate(948,61)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#939594",
    transform: "translate(998,58)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#949897",
    transform: "translate(1045,45)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#939695",
    transform: "translate(996,45)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929494",
    transform: "translate(948,45)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#98999A",
    transform: "translate(1090,43)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#929594",
    transform: "translate(948,37)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#959797",
    transform: "translate(998,34)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949694",
    transform: "translate(948,29)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#9A9B9C",
    transform: "translate(1090,27)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949696",
    transform: "translate(948,21)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#949797",
    transform: "translate(948,13)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#959898",
    transform: "translate(948,5)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9E9F9F",
    transform: "translate(948,1021)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA1",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A4A4A6",
    transform: "translate(82,1021)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A3A4A5",
    transform: "translate(84,1018)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA1A0",
    transform: "translate(995,1014)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A0",
    transform: "translate(1042,1013)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A3",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A0A1A2",
    transform: "translate(1090,1003)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA1A2",
    transform: "translate(1089,1001)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA1A1",
    transform: "translate(1042,997)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA0A1",
    transform: "translate(1090,979)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9D9F9F",
    transform: "translate(1042,973)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A2",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C9F9F",
    transform: "translate(1042,965)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A4",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C9EA0",
    transform: "translate(1090,955)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9B9E9E",
    transform: "translate(1042,949)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989B9B",
    transform: "translate(948,949)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C9E9F",
    transform: "translate(1090,947)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989B9B",
    transform: "translate(948,941)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9A9D9D",
    transform: "translate(1042,933)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9C",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999C9C",
    transform: "translate(1042,917)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97989A",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9B9C9D",
    transform: "translate(1090,915)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999C9D",
    transform: "translate(1090,899)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949897",
    transform: "translate(948,893)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939897",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979A9A",
    transform: "translate(1042,885)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989B9B",
    transform: "translate(1090,883)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959999",
    transform: "translate(998,883)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A0A1A2",
    transform: "translate(82,877)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989A9A",
    transform: "translate(1090,875)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#969999",
    transform: "translate(1042,869)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979999",
    transform: "translate(1068,865)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939796",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9C",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A1",
    transform: "translate(82,861)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979899",
    transform: "translate(1068,857)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949898",
    transform: "translate(1042,853)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#919493",
    transform: "translate(948,853)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979999",
    transform: "translate(1090,851)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949897",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949897",
    transform: "translate(1042,845)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A0A1A1",
    transform: "translate(82,845)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979899",
    transform: "translate(1090,843)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959998",
    transform: "translate(1089,841)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#909390",
    transform: "translate(926,834)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949896",
    transform: "translate(1042,829)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#969998",
    transform: "translate(1090,827)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949695",
    transform: "translate(1042,821)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#90918F",
    transform: "translate(948,821)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A1",
    transform: "translate(85,813)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#969797",
    transform: "translate(1090,811)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939594",
    transform: "translate(1042,805)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9486",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90938F",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959797",
    transform: "translate(1090,795)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91938F",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#929492",
    transform: "translate(1042,789)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA0A1",
    transform: "translate(82,789)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#90918E",
    transform: "translate(996,788)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#929491",
    transform: "translate(1042,781)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928D",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908B7D",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919391",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3937C",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959694",
    transform: "translate(1090,771)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928C",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA1A0",
    transform: "translate(84,770)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59478",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#929390",
    transform: "translate(1042,765)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908C",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#91938F",
    transform: "translate(1042,757)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F8B",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949594",
    transform: "translate(1090,755)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908A",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA09F",
    transform: "translate(85,749)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8A",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939493",
    transform: "translate(1090,747)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928C",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939493",
    transform: "translate(1090,739)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F88",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F87",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA0A0",
    transform: "translate(82,733)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F87",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E85",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E85",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E83",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#92918A",
    transform: "translate(1042,717)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F9FA0",
    transform: "translate(82,717)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939390",
    transform: "translate(1090,715)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89764",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D81",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939088",
    transform: "translate(1042,701)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9763",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93928F",
    transform: "translate(1090,699)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D7F",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D80",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F87",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#978A76",
    transform: "translate(948,693)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD9761",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93928D",
    transform: "translate(1090,691)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958C7E",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7D",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#92928D",
    transform: "translate(1090,675)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7C",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F83",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#958F83",
    transform: "translate(1042,669)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C8A70",
    transform: "translate(948,669)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#94918C",
    transform: "translate(1090,667)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988D7C",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988B7A",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1995B",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998C7B",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3A323",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9E8A6C",
    transform: "translate(948,661)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93918B",
    transform: "translate(1090,659)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D79",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988C78",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#968F81",
    transform: "translate(1042,653)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#95918A",
    transform: "translate(1090,651)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8C78",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968D80",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985C",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8D76",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959088",
    transform: "translate(1090,643)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#988F7E",
    transform: "translate(1042,637)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A58B65",
    transform: "translate(948,637)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#969087",
    transform: "translate(1090,635)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985A",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7D",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#998E7C",
    transform: "translate(1042,629)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8C6F",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9A8E7B",
    transform: "translate(1044,622)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8E7B",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#978F85",
    transform: "translate(1090,619)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18C6F",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28E6F",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B18F5D",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969594",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#988F83",
    transform: "translate(1090,611)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999083",
    transform: "translate(1090,603)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#998E81",
    transform: "translate(1090,595)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A08F75",
    transform: "translate(1042,589)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F9FA0",
    transform: "translate(82,589)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A28F72",
    transform: "translate(1042,581)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7F",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A48F71",
    transform: "translate(1042,573)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28F72",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B08F61",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C8F7E",
    transform: "translate(1090,571)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9062",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19062",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA09F",
    transform: "translate(85,565)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58F71",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9C907D",
    transform: "translate(1090,563)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39161",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9E8F7C",
    transform: "translate(1090,555)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6915E",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F907B",
    transform: "translate(1090,539)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A0907B",
    transform: "translate(1090,531)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928E",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AB926B",
    transform: "translate(1042,517)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9558",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA0A1",
    transform: "translate(82,501)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A29178",
    transform: "translate(1090,499)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B09368",
    transform: "translate(1042,485)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B29367",
    transform: "translate(1042,477)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A39177",
    transform: "translate(1090,467)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC984E",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39366",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,445)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A49176",
    transform: "translate(1090,443)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B59465",
    transform: "translate(1044,438)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF994A",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A59276",
    transform: "translate(1090,427)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD994B",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59464",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A69275",
    transform: "translate(1090,411)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A59276",
    transform: "translate(1090,395)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA9370",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49465",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A69175",
    transform: "translate(1090,387)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA0A0",
    transform: "translate(85,381)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49366",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA9370",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB994E",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39467",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A1",
    transform: "translate(82,365)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A39278",
    transform: "translate(1090,355)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B19467",
    transform: "translate(1044,350)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A59277",
    transform: "translate(1090,347)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#B09368",
    transform: "translate(1044,342)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA1A0",
    transform: "translate(85,341)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9269",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A29078",
    transform: "translate(1090,323)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C09657",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC916B",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A29078",
    transform: "translate(1090,315)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE9558",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926B",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A09079",
    transform: "translate(1090,307)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#AB936D",
    transform: "translate(1042,301)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F917B",
    transform: "translate(1090,299)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9935C",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F917B",
    transform: "translate(1090,291)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29261",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9E907F",
    transform: "translate(1090,275)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE9166",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC926A",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9166",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A19076",
    transform: "translate(1042,261)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9906A",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4906E",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8906D",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9F9078",
    transform: "translate(1042,253)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9079",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999084",
    transform: "translate(1090,251)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6906D",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38F74",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989085",
    transform: "translate(1090,243)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49072",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989185",
    transform: "translate(1089,241)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979086",
    transform: "translate(1090,235)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F75",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9A907F",
    transform: "translate(1042,229)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F77",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979083",
    transform: "translate(1068,225)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998F81",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959189",
    transform: "translate(1090,219)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#968E85",
    transform: "translate(1068,217)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E79",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#978F81",
    transform: "translate(1042,213)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#949189",
    transform: "translate(1090,211)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949189",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7B",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F82",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9E8C73",
    transform: "translate(948,205)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58C69",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988D7D",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998E7A",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F84",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988E7E",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#958F85",
    transform: "translate(1042,189)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978D81",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93918C",
    transform: "translate(1090,187)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968E7F",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93918D",
    transform: "translate(1090,179)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#948E83",
    transform: "translate(998,179)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D80",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929089",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#929189",
    transform: "translate(1042,165)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#948C7D",
    transform: "translate(948,165)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#93928F",
    transform: "translate(1090,163)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F89",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959391",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E85",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#92908B",
    transform: "translate(1042,157)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918D86",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F87",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908C",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#928C81",
    transform: "translate(948,149)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918D",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939290",
    transform: "translate(1090,147)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F88",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908B7E",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#91928D",
    transform: "translate(1042,141)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#91918E",
    transform: "translate(1042,133)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9FA2A3",
    transform: "translate(85,133)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908A",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939493",
    transform: "translate(1090,123)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8B82",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8B",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#919392",
    transform: "translate(1042,101)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928F",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919190",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908E",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959797",
    transform: "translate(1090,83)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#969998",
    transform: "translate(1090,67)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929495",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#979999",
    transform: "translate(1090,59)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929494",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989999",
    transform: "translate(1090,51)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959997",
    transform: "translate(1042,45)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#959797",
    transform: "translate(995,38)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A3A4A6",
    transform: "translate(82,37)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999A9B",
    transform: "translate(1090,35)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939595",
    transform: "translate(636,17)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9B9C9D",
    transform: "translate(1090,11)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#999B9C",
    transform: "translate(1042,5)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A4A5A6",
    transform: "translate(85,5)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#989B9B",
    transform: "translate(996,1)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A3",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A6A5",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A6A7",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9EA1",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9F",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A6",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A2",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A0A2",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A6A5",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA0",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A3",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A5",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A4",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A5",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A0",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A2",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A3A5",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A5",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A2",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A3",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA3A1",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA19E",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A5",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9F",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A6",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A4",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A6",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A6",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A6A4",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A2",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9F",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9E",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9C",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A4",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A4",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A0",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A6A4",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A6",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A5",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A1",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A6",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9FA0",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A1",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A0A4",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A5A4",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A2",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9B",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9EA0",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A3",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9D",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A2",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A7A6",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A4A5",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A1",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9C",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A5",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A5",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A19F",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A2",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09D",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A3",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A4",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A5",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A5",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A5",
    transform: "translate(0,0)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A6",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A4",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A6",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A1",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A0",
    transform: "translate(0,0)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A0",
    transform: "translate(0,0)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9E",
    transform: "translate(0,0)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A5",
    transform: "translate(0,0)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A5",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09D",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A3",
    transform: "translate(0,0)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A2",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A6",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9E",
    transform: "translate(0,0)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A4",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A6",
    transform: "translate(0,0)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A3",
    transform: "translate(0,0)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9B",
    transform: "translate(0,0)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA1",
    transform: "translate(0,0)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09FA0",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9F",
    transform: "translate(0,0)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D9D",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9E",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A2",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A4",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9E",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A3",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9F",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A3",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9F9E",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9B",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A3",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA0",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9E",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9C",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9B",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9E",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A4",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A4",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9C",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9C9C",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A3",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9C",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A1",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA0",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9E",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9D",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A999A",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9D",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D9C",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9D",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9E",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999B",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A3",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A2",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19FA1",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979C99",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A5",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9E",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A99",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A1",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA2",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9A",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9D",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999B",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979D9D",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA1",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9DA0",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9E",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9E",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9EA0",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A9A",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A9B",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A4",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9C",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959899",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979C9B",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9C",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979C9C",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A2",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D9C",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C99",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9EA0",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9E",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A97",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959798",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98979A",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999B",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA1",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999B",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979C9B",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949A9B",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959798",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A3",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A2",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9D",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A4",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA2",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9F",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9C",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9C",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95999A",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959798",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9C",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9D",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9C",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949897",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B98",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9C",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9B",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D9B",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949798",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A3",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949898",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA3",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9F",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A99",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949898",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959998",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9C",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949597",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA2A2",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949898",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9D",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A9A",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939797",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929797",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9DA0",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9C",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A99",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9D",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939996",
    transform: "translate(0,0)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A3",
    transform: "translate(0,0)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A3",
    transform: "translate(0,0)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9B",
    transform: "translate(0,0)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959596",
    transform: "translate(0,0)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959799",
    transform: "translate(0,0)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999B",
    transform: "translate(0,0)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959795",
    transform: "translate(0,0)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9B",
    transform: "translate(0,0)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949898",
    transform: "translate(0,0)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929694",
    transform: "translate(0,0)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959896",
    transform: "translate(0,0)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A2",
    transform: "translate(0,0)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969B9B",
    transform: "translate(0,0)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9F",
    transform: "translate(0,0)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989797",
    transform: "translate(0,0)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949794",
    transform: "translate(0,0)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949897",
    transform: "translate(0,0)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9E",
    transform: "translate(0,0)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949898",
    transform: "translate(0,0)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959494",
    transform: "translate(0,0)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929693",
    transform: "translate(0,0)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949998",
    transform: "translate(0,0)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9F",
    transform: "translate(0,0)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919595",
    transform: "translate(0,0)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A3",
    transform: "translate(0,0)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9D",
    transform: "translate(0,0)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939697",
    transform: "translate(0,0)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919496",
    transform: "translate(0,0)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9E",
    transform: "translate(0,0)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9C",
    transform: "translate(0,0)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919494",
    transform: "translate(0,0)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949794",
    transform: "translate(0,0)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939897",
    transform: "translate(0,0)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959996",
    transform: "translate(0,0)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9D",
    transform: "translate(0,0)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9B",
    transform: "translate(0,0)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959998",
    transform: "translate(0,0)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919594",
    transform: "translate(0,0)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929796",
    transform: "translate(0,0)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95999A",
    transform: "translate(0,0)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9493",
    transform: "translate(0,0)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969794",
    transform: "translate(0,0)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909593",
    transform: "translate(0,0)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9F",
    transform: "translate(0,0)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929696",
    transform: "translate(0,0)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A1",
    transform: "translate(0,0)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA1",
    transform: "translate(0,0)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9D",
    transform: "translate(0,0)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909394",
    transform: "translate(0,0)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969895",
    transform: "translate(0,0)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929797",
    transform: "translate(0,0)"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9A",
    transform: "translate(0,0)"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C99",
    transform: "translate(0,0)"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929595",
    transform: "translate(0,0)"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929694",
    transform: "translate(0,0)"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929292",
    transform: "translate(0,0)"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919291",
    transform: "translate(0,0)"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959698",
    transform: "translate(0,0)"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939898",
    transform: "translate(0,0)"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929691",
    transform: "translate(0,0)"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959693",
    transform: "translate(0,0)"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959693",
    transform: "translate(0,0)"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B98",
    transform: "translate(0,0)"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9D",
    transform: "translate(0,0)"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9C",
    transform: "translate(0,0)"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9D",
    transform: "translate(0,0)"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929695",
    transform: "translate(0,0)"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909293",
    transform: "translate(0,0)"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909391",
    transform: "translate(0,0)"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919291",
    transform: "translate(0,0)"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979693",
    transform: "translate(0,0)"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98989B",
    transform: "translate(0,0)"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9A9C",
    transform: "translate(0,0)"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949897",
    transform: "translate(0,0)"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949390",
    transform: "translate(0,0)"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969793",
    transform: "translate(0,0)"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C99",
    transform: "translate(0,0)"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959899",
    transform: "translate(0,0)"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939797",
    transform: "translate(0,0)"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969692",
    transform: "translate(0,0)"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A99",
    transform: "translate(0,0)"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9EA0",
    transform: "translate(0,0)"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919494",
    transform: "translate(0,0)"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909190",
    transform: "translate(0,0)"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979893",
    transform: "translate(0,0)"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919496",
    transform: "translate(0,0)"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939697",
    transform: "translate(0,0)"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90938F",
    transform: "translate(0,0)"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938F",
    transform: "translate(0,0)"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A2",
    transform: "translate(0,0)"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A3",
    transform: "translate(0,0)"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A98",
    transform: "translate(0,0)"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939796",
    transform: "translate(0,0)"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9190",
    transform: "translate(0,0)"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939290",
    transform: "translate(0,0)"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA1",
    transform: "translate(0,0)"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A98",
    transform: "translate(0,0)"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909392",
    transform: "translate(0,0)"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9291",
    transform: "translate(0,0)"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918E",
    transform: "translate(0,0)"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9B",
    transform: "translate(0,0)"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918F",
    transform: "translate(0,0)"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93948D",
    transform: "translate(0,0)"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979692",
    transform: "translate(0,0)"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979693",
    transform: "translate(0,0)"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9B",
    transform: "translate(0,0)"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9A",
    transform: "translate(0,0)"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A97",
    transform: "translate(0,0)"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909290",
    transform: "translate(0,0)"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F928E",
    transform: "translate(0,0)"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948D",
    transform: "translate(0,0)"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959590",
    transform: "translate(0,0)"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919595",
    transform: "translate(0,0)"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919593",
    transform: "translate(0,0)"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9492",
    transform: "translate(0,0)"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999791",
    transform: "translate(0,0)"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A3",
    transform: "translate(0,0)"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9493",
    transform: "translate(0,0)"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908D",
    transform: "translate(0,0)"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928B",
    transform: "translate(0,0)"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98968E",
    transform: "translate(0,0)"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979590",
    transform: "translate(0,0)"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989691",
    transform: "translate(0,0)"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9491",
    transform: "translate(0,0)"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979691",
    transform: "translate(0,0)"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959997",
    transform: "translate(0,0)"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F928E",
    transform: "translate(0,0)"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E918C",
    transform: "translate(0,0)"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989798",
    transform: "translate(0,0)"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93908A",
    transform: "translate(0,0)"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958E",
    transform: "translate(0,0)"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939794",
    transform: "translate(0,0)"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8B",
    transform: "translate(0,0)"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A5",
    transform: "translate(0,0)"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A99",
    transform: "translate(0,0)"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929595",
    transform: "translate(0,0)"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919191",
    transform: "translate(0,0)"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8E",
    transform: "translate(0,0)"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8C",
    transform: "translate(0,0)"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8C",
    transform: "translate(0,0)"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958F",
    transform: "translate(0,0)"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958E",
    transform: "translate(0,0)"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969B9B",
    transform: "translate(0,0)"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A98",
    transform: "translate(0,0)"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929494",
    transform: "translate(0,0)"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9290",
    transform: "translate(0,0)"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908F",
    transform: "translate(0,0)"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969389",
    transform: "translate(0,0)"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97968C",
    transform: "translate(0,0)"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989896",
    transform: "translate(0,0)"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939796",
    transform: "translate(0,0)"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919595",
    transform: "translate(0,0)"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919391",
    transform: "translate(0,0)"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929089",
    transform: "translate(0,0)"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99958B",
    transform: "translate(0,0)"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9F",
    transform: "translate(0,0)"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9190",
    transform: "translate(0,0)"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989899",
    transform: "translate(0,0)"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939493",
    transform: "translate(0,0)"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8D",
    transform: "translate(0,0)"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918A",
    transform: "translate(0,0)"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969188",
    transform: "translate(0,0)"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A968D",
    transform: "translate(0,0)"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958E",
    transform: "translate(0,0)"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9EA1",
    transform: "translate(0,0)"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9A",
    transform: "translate(0,0)"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959896",
    transform: "translate(0,0)"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90938F",
    transform: "translate(0,0)"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918D",
    transform: "translate(0,0)"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999489",
    transform: "translate(0,0)"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958D",
    transform: "translate(0,0)"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9B",
    transform: "translate(0,0)"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959798",
    transform: "translate(0,0)"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918E",
    transform: "translate(0,0)"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928F",
    transform: "translate(0,0)"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979084",
    transform: "translate(0,0)"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9488",
    transform: "translate(0,0)"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919492",
    transform: "translate(0,0)"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98948A",
    transform: "translate(0,0)"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949794",
    transform: "translate(0,0)"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929592",
    transform: "translate(0,0)"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918F",
    transform: "translate(0,0)"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8C",
    transform: "translate(0,0)"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E88",
    transform: "translate(0,0)"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989085",
    transform: "translate(0,0)"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9483",
    transform: "translate(0,0)"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B958B",
    transform: "translate(0,0)"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8A",
    transform: "translate(0,0)"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9482",
    transform: "translate(0,0)"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979794",
    transform: "translate(0,0)"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA3A0",
    transform: "translate(0,0)"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929592",
    transform: "translate(0,0)"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918E",
    transform: "translate(0,0)"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9182",
    transform: "translate(0,0)"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9381",
    transform: "translate(0,0)"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9485",
    transform: "translate(0,0)"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949894",
    transform: "translate(0,0)"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90938F",
    transform: "translate(0,0)"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E87",
    transform: "translate(0,0)"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A0",
    transform: "translate(0,0)"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939695",
    transform: "translate(0,0)"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918E",
    transform: "translate(0,0)"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E937F",
    transform: "translate(0,0)"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9689",
    transform: "translate(0,0)"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919492",
    transform: "translate(0,0)"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E918E",
    transform: "translate(0,0)"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A0",
    transform: "translate(0,0)"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09680",
    transform: "translate(0,0)"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908A",
    transform: "translate(0,0)"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959998",
    transform: "translate(0,0)"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908D",
    transform: "translate(0,0)"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E83",
    transform: "translate(0,0)"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D917F",
    transform: "translate(0,0)"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9387",
    transform: "translate(0,0)"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939693",
    transform: "translate(0,0)"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919492",
    transform: "translate(0,0)"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919390",
    transform: "translate(0,0)"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA1A0",
    transform: "translate(0,0)"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B99",
    transform: "translate(0,0)"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918D84",
    transform: "translate(0,0)"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969697",
    transform: "translate(0,0)"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B97",
    transform: "translate(0,0)"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919390",
    transform: "translate(0,0)"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919291",
    transform: "translate(0,0)"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9585",
    transform: "translate(0,0)"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908D",
    transform: "translate(0,0)"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A97",
    transform: "translate(0,0)"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959998",
    transform: "translate(0,0)"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919490",
    transform: "translate(0,0)"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908C",
    transform: "translate(0,0)"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F8C",
    transform: "translate(0,0)"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7F",
    transform: "translate(0,0)"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907B",
    transform: "translate(0,0)"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09480",
    transform: "translate(0,0)"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9585",
    transform: "translate(0,0)"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9385",
    transform: "translate(0,0)"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948F",
    transform: "translate(0,0)"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A98",
    transform: "translate(0,0)"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939493",
    transform: "translate(0,0)"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C86",
    transform: "translate(0,0)"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9BA09D",
    transform: "translate(0,0)"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A2",
    transform: "translate(0,0)"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928F",
    transform: "translate(0,0)"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918D",
    transform: "translate(0,0)"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C82",
    transform: "translate(0,0)"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59376",
    transform: "translate(0,0)"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9585",
    transform: "translate(0,0)"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9485",
    transform: "translate(0,0)"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E918E",
    transform: "translate(0,0)"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939693",
    transform: "translate(0,0)"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8B",
    transform: "translate(0,0)"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7E",
    transform: "translate(0,0)"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8A",
    transform: "translate(0,0)"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F928F",
    transform: "translate(0,0)"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8A",
    transform: "translate(0,0)"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908A",
    transform: "translate(0,0)"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2947D",
    transform: "translate(0,0)"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59574",
    transform: "translate(0,0)"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90938F",
    transform: "translate(0,0)"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938E",
    transform: "translate(0,0)"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908D",
    transform: "translate(0,0)"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989799",
    transform: "translate(0,0)"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969799",
    transform: "translate(0,0)"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908C",
    transform: "translate(0,0)"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A80",
    transform: "translate(0,0)"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958A7E",
    transform: "translate(0,0)"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19482",
    transform: "translate(0,0)"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9482",
    transform: "translate(0,0)"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D88",
    transform: "translate(0,0)"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D86",
    transform: "translate(0,0)"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948B7D",
    transform: "translate(0,0)"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A2",
    transform: "translate(0,0)"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949896",
    transform: "translate(0,0)"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949693",
    transform: "translate(0,0)"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F928E",
    transform: "translate(0,0)"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8A",
    transform: "translate(0,0)"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8A7A",
    transform: "translate(0,0)"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18F77",
    transform: "translate(0,0)"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59174",
    transform: "translate(0,0)"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6947A",
    transform: "translate(0,0)"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9581",
    transform: "translate(0,0)"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949895",
    transform: "translate(0,0)"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918D",
    transform: "translate(0,0)"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8A81",
    transform: "translate(0,0)"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908980",
    transform: "translate(0,0)"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A2",
    transform: "translate(0,0)"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A99",
    transform: "translate(0,0)"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979996",
    transform: "translate(0,0)"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C86",
    transform: "translate(0,0)"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968A7D",
    transform: "translate(0,0)"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4947E",
    transform: "translate(0,0)"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19480",
    transform: "translate(0,0)"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A97",
    transform: "translate(0,0)"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939491",
    transform: "translate(0,0)"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908C",
    transform: "translate(0,0)"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D87",
    transform: "translate(0,0)"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C82",
    transform: "translate(0,0)"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998B79",
    transform: "translate(0,0)"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3957E",
    transform: "translate(0,0)"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959794",
    transform: "translate(0,0)"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989793",
    transform: "translate(0,0)"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E88",
    transform: "translate(0,0)"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908B87",
    transform: "translate(0,0)"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8C78",
    transform: "translate(0,0)"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48F72",
    transform: "translate(0,0)"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9573",
    transform: "translate(0,0)"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918D",
    transform: "translate(0,0)"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928D",
    transform: "translate(0,0)"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D86",
    transform: "translate(0,0)"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9C",
    transform: "translate(0,0)"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919491",
    transform: "translate(0,0)"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D85",
    transform: "translate(0,0)"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C85",
    transform: "translate(0,0)"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908980",
    transform: "translate(0,0)"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A7D",
    transform: "translate(0,0)"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5957D",
    transform: "translate(0,0)"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3957F",
    transform: "translate(0,0)"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8F8A",
    transform: "translate(0,0)"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908B",
    transform: "translate(0,0)"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D85",
    transform: "translate(0,0)"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918B80",
    transform: "translate(0,0)"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B7A",
    transform: "translate(0,0)"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8D74",
    transform: "translate(0,0)"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4947B",
    transform: "translate(0,0)"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E9F",
    transform: "translate(0,0)"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918B",
    transform: "translate(0,0)"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918F",
    transform: "translate(0,0)"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E87",
    transform: "translate(0,0)"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8B82",
    transform: "translate(0,0)"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8C75",
    transform: "translate(0,0)"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8D72",
    transform: "translate(0,0)"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB9673",
    transform: "translate(0,0)"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908B",
    transform: "translate(0,0)"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959896",
    transform: "translate(0,0)"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929590",
    transform: "translate(0,0)"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918D",
    transform: "translate(0,0)"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C83",
    transform: "translate(0,0)"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A5A3",
    transform: "translate(0,0)"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918F",
    transform: "translate(0,0)"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918D",
    transform: "translate(0,0)"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C83",
    transform: "translate(0,0)"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93897A",
    transform: "translate(0,0)"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A99679",
    transform: "translate(0,0)"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5957C",
    transform: "translate(0,0)"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E89",
    transform: "translate(0,0)"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939591",
    transform: "translate(0,0)"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8A",
    transform: "translate(0,0)"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C85",
    transform: "translate(0,0)"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91897F",
    transform: "translate(0,0)"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D84",
    transform: "translate(0,0)"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C82",
    transform: "translate(0,0)"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D85",
    transform: "translate(0,0)"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C83",
    transform: "translate(0,0)"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8A80",
    transform: "translate(0,0)"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD9662",
    transform: "translate(0,0)"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09670",
    transform: "translate(0,0)"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A79578",
    transform: "translate(0,0)"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92948F",
    transform: "translate(0,0)"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918C",
    transform: "translate(0,0)"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919189",
    transform: "translate(0,0)"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E85",
    transform: "translate(0,0)"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8B83",
    transform: "translate(0,0)"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90897B",
    transform: "translate(0,0)"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928979",
    transform: "translate(0,0)"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A99",
    transform: "translate(0,0)"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989896",
    transform: "translate(0,0)"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969693",
    transform: "translate(0,0)"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959795",
    transform: "translate(0,0)"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908C",
    transform: "translate(0,0)"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F89",
    transform: "translate(0,0)"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D84",
    transform: "translate(0,0)"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8B82",
    transform: "translate(0,0)"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91887B",
    transform: "translate(0,0)"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948A77",
    transform: "translate(0,0)"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9677",
    transform: "translate(0,0)"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89579",
    transform: "translate(0,0)"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09581",
    transform: "translate(0,0)"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989997",
    transform: "translate(0,0)"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A96",
    transform: "translate(0,0)"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949896",
    transform: "translate(0,0)"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929692",
    transform: "translate(0,0)"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D83",
    transform: "translate(0,0)"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B7C",
    transform: "translate(0,0)"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D83",
    transform: "translate(0,0)"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD9776",
    transform: "translate(0,0)"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949896",
    transform: "translate(0,0)"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8C83",
    transform: "translate(0,0)"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C6F",
    transform: "translate(0,0)"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59264",
    transform: "translate(0,0)"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89678",
    transform: "translate(0,0)"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC995D",
    transform: "translate(0,0)"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB9574",
    transform: "translate(0,0)"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B99",
    transform: "translate(0,0)"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9F",
    transform: "translate(0,0)"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918C",
    transform: "translate(0,0)"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929088",
    transform: "translate(0,0)"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948976",
    transform: "translate(0,0)"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8871",
    transform: "translate(0,0)"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999897",
    transform: "translate(0,0)"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979695",
    transform: "translate(0,0)"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919088",
    transform: "translate(0,0)"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948875",
    transform: "translate(0,0)"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59364",
    transform: "translate(0,0)"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9773",
    transform: "translate(0,0)"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E9E",
    transform: "translate(0,0)"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09E",
    transform: "translate(0,0)"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D86",
    transform: "translate(0,0)"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F89",
    transform: "translate(0,0)"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E87",
    transform: "translate(0,0)"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B82",
    transform: "translate(0,0)"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C6E",
    transform: "translate(0,0)"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949592",
    transform: "translate(0,0)"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9772",
    transform: "translate(0,0)"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939493",
    transform: "translate(0,0)"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918B82",
    transform: "translate(0,0)"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918C81",
    transform: "translate(0,0)"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B80",
    transform: "translate(0,0)"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48C6C",
    transform: "translate(0,0)"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99967",
    transform: "translate(0,0)"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD9772",
    transform: "translate(0,0)"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9B",
    transform: "translate(0,0)"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939392",
    transform: "translate(0,0)"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9571",
    transform: "translate(0,0)"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969B99",
    transform: "translate(0,0)"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9E",
    transform: "translate(0,0)"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949693",
    transform: "translate(0,0)"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E87",
    transform: "translate(0,0)"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F86",
    transform: "translate(0,0)"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9B",
    transform: "translate(0,0)"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9BA0A0",
    transform: "translate(0,0)"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999B",
    transform: "translate(0,0)"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969794",
    transform: "translate(0,0)"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918D",
    transform: "translate(0,0)"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E88",
    transform: "translate(0,0)"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F85",
    transform: "translate(0,0)"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A7E",
    transform: "translate(0,0)"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938876",
    transform: "translate(0,0)"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978873",
    transform: "translate(0,0)"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09672",
    transform: "translate(0,0)"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F88",
    transform: "translate(0,0)"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E86",
    transform: "translate(0,0)"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A7E",
    transform: "translate(0,0)"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968A73",
    transform: "translate(0,0)"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8A6D",
    transform: "translate(0,0)"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF9A4C",
    transform: "translate(0,0)"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D69F4A",
    transform: "translate(0,0)"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1976E",
    transform: "translate(0,0)"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A99",
    transform: "translate(0,0)"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939491",
    transform: "translate(0,0)"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D79F48",
    transform: "translate(0,0)"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959899",
    transform: "translate(0,0)"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928D",
    transform: "translate(0,0)"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F87",
    transform: "translate(0,0)"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C80",
    transform: "translate(0,0)"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939690",
    transform: "translate(0,0)"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E85",
    transform: "translate(0,0)"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929592",
    transform: "translate(0,0)"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F88",
    transform: "translate(0,0)"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E896D",
    transform: "translate(0,0)"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9B",
    transform: "translate(0,0)"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989797",
    transform: "translate(0,0)"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949492",
    transform: "translate(0,0)"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92897D",
    transform: "translate(0,0)"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978773",
    transform: "translate(0,0)"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968672",
    transform: "translate(0,0)"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988870",
    transform: "translate(0,0)"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4976E",
    transform: "translate(0,0)"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9572",
    transform: "translate(0,0)"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A2A2",
    transform: "translate(0,0)"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D83",
    transform: "translate(0,0)"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969895",
    transform: "translate(0,0)"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92958F",
    transform: "translate(0,0)"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928C",
    transform: "translate(0,0)"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E83",
    transform: "translate(0,0)"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68C67",
    transform: "translate(0,0)"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4957B",
    transform: "translate(0,0)"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9D",
    transform: "translate(0,0)"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908D",
    transform: "translate(0,0)"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918D83",
    transform: "translate(0,0)"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B7F",
    transform: "translate(0,0)"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A7E",
    transform: "translate(0,0)"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938B7E",
    transform: "translate(0,0)"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8D65",
    transform: "translate(0,0)"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB9E30",
    transform: "translate(0,0)"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928B",
    transform: "translate(0,0)"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919189",
    transform: "translate(0,0)"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929085",
    transform: "translate(0,0)"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9582",
    transform: "translate(0,0)"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A2",
    transform: "translate(0,0)"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969596",
    transform: "translate(0,0)"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908B",
    transform: "translate(0,0)"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E89",
    transform: "translate(0,0)"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E85",
    transform: "translate(0,0)"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E86",
    transform: "translate(0,0)"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988771",
    transform: "translate(0,0)"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B886D",
    transform: "translate(0,0)"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6976B",
    transform: "translate(0,0)"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0976F",
    transform: "translate(0,0)"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4976B",
    transform: "translate(0,0)"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969894",
    transform: "translate(0,0)"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91938E",
    transform: "translate(0,0)"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918A",
    transform: "translate(0,0)"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D83",
    transform: "translate(0,0)"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B79869",
    transform: "translate(0,0)"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959693",
    transform: "translate(0,0)"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939491",
    transform: "translate(0,0)"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918A",
    transform: "translate(0,0)"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929085",
    transform: "translate(0,0)"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938B7D",
    transform: "translate(0,0)"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB9B4D",
    transform: "translate(0,0)"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7A137",
    transform: "translate(0,0)"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49A5C",
    transform: "translate(0,0)"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908B",
    transform: "translate(0,0)"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929289",
    transform: "translate(0,0)"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929087",
    transform: "translate(0,0)"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E80",
    transform: "translate(0,0)"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94897C",
    transform: "translate(0,0)"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938A79",
    transform: "translate(0,0)"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979593",
    transform: "translate(0,0)"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939591",
    transform: "translate(0,0)"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D85",
    transform: "translate(0,0)"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D84",
    transform: "translate(0,0)"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D896A",
    transform: "translate(0,0)"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99868",
    transform: "translate(0,0)"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3966D",
    transform: "translate(0,0)"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918C7F",
    transform: "translate(0,0)"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979798",
    transform: "translate(0,0)"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969994",
    transform: "translate(0,0)"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938D",
    transform: "translate(0,0)"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D83",
    transform: "translate(0,0)"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948A7B",
    transform: "translate(0,0)"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A98A63",
    transform: "translate(0,0)"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECA330",
    transform: "translate(0,0)"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99767",
    transform: "translate(0,0)"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2966B",
    transform: "translate(0,0)"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999692",
    transform: "translate(0,0)"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949390",
    transform: "translate(0,0)"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938F",
    transform: "translate(0,0)"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968B79",
    transform: "translate(0,0)"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A2",
    transform: "translate(0,0)"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908A",
    transform: "translate(0,0)"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918D85",
    transform: "translate(0,0)"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E84",
    transform: "translate(0,0)"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948B7B",
    transform: "translate(0,0)"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B18E5F",
    transform: "translate(0,0)"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C99751",
    transform: "translate(0,0)"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E83",
    transform: "translate(0,0)"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA19F",
    transform: "translate(0,0)"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939591",
    transform: "translate(0,0)"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949392",
    transform: "translate(0,0)"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919289",
    transform: "translate(0,0)"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E86",
    transform: "translate(0,0)"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E84",
    transform: "translate(0,0)"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E80",
    transform: "translate(0,0)"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89965",
    transform: "translate(0,0)"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9C",
    transform: "translate(0,0)"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19E",
    transform: "translate(0,0)"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9E",
    transform: "translate(0,0)"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9A",
    transform: "translate(0,0)"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F89",
    transform: "translate(0,0)"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93908A",
    transform: "translate(0,0)"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E85",
    transform: "translate(0,0)"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D83",
    transform: "translate(0,0)"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958876",
    transform: "translate(0,0)"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9866",
    transform: "translate(0,0)"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A3",
    transform: "translate(0,0)"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949895",
    transform: "translate(0,0)"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928F",
    transform: "translate(0,0)"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939088",
    transform: "translate(0,0)"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958A79",
    transform: "translate(0,0)"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938D",
    transform: "translate(0,0)"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09D",
    transform: "translate(0,0)"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949693",
    transform: "translate(0,0)"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949592",
    transform: "translate(0,0)"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918D",
    transform: "translate(0,0)"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918C",
    transform: "translate(0,0)"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F88",
    transform: "translate(0,0)"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958B78",
    transform: "translate(0,0)"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C99A55",
    transform: "translate(0,0)"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89864",
    transform: "translate(0,0)"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EDA42D",
    transform: "translate(0,0)"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938F",
    transform: "translate(0,0)"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968975",
    transform: "translate(0,0)"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B97",
    transform: "translate(0,0)"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9C",
    transform: "translate(0,0)"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979798",
    transform: "translate(0,0)"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969594",
    transform: "translate(0,0)"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969492",
    transform: "translate(0,0)"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928C",
    transform: "translate(0,0)"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18965",
    transform: "translate(0,0)"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938C7D",
    transform: "translate(0,0)"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959793",
    transform: "translate(0,0)"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949692",
    transform: "translate(0,0)"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918B",
    transform: "translate(0,0)"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949088",
    transform: "translate(0,0)"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968B76",
    transform: "translate(0,0)"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988B77",
    transform: "translate(0,0)"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2A327",
    transform: "translate(0,0)"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928E",
    transform: "translate(0,0)"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9B",
    transform: "translate(0,0)"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9F",
    transform: "translate(0,0)"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918B",
    transform: "translate(0,0)"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F87",
    transform: "translate(0,0)"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978A77",
    transform: "translate(0,0)"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978B76",
    transform: "translate(0,0)"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC9A52",
    transform: "translate(0,0)"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928C",
    transform: "translate(0,0)"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968D81",
    transform: "translate(0,0)"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948C7E",
    transform: "translate(0,0)"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9661",
    transform: "translate(0,0)"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949590",
    transform: "translate(0,0)"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D80",
    transform: "translate(0,0)"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958B7A",
    transform: "translate(0,0)"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978872",
    transform: "translate(0,0)"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A1",
    transform: "translate(0,0)"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918D",
    transform: "translate(0,0)"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908D",
    transform: "translate(0,0)"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F86",
    transform: "translate(0,0)"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F86",
    transform: "translate(0,0)"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968C83",
    transform: "translate(0,0)"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7F",
    transform: "translate(0,0)"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998872",
    transform: "translate(0,0)"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928E",
    transform: "translate(0,0)"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B896E",
    transform: "translate(0,0)"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58763",
    transform: "translate(0,0)"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A1",
    transform: "translate(0,0)"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969793",
    transform: "translate(0,0)"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918B",
    transform: "translate(0,0)"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F87",
    transform: "translate(0,0)"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938E80",
    transform: "translate(0,0)"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7F",
    transform: "translate(0,0)"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968C7D",
    transform: "translate(0,0)"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988973",
    transform: "translate(0,0)"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF8D5D",
    transform: "translate(0,0)"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2A326",
    transform: "translate(0,0)"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928E",
    transform: "translate(0,0)"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928D",
    transform: "translate(0,0)"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F8C",
    transform: "translate(0,0)"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19E",
    transform: "translate(0,0)"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9C",
    transform: "translate(0,0)"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959492",
    transform: "translate(0,0)"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928D",
    transform: "translate(0,0)"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938E",
    transform: "translate(0,0)"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928D",
    transform: "translate(0,0)"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949089",
    transform: "translate(0,0)"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F86",
    transform: "translate(0,0)"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D81",
    transform: "translate(0,0)"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998B75",
    transform: "translate(0,0)"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998A73",
    transform: "translate(0,0)"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A876C",
    transform: "translate(0,0)"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9761",
    transform: "translate(0,0)"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9B",
    transform: "translate(0,0)"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D7B",
    transform: "translate(0,0)"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9B",
    transform: "translate(0,0)"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959495",
    transform: "translate(0,0)"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938E",
    transform: "translate(0,0)"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918D",
    transform: "translate(0,0)"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978D82",
    transform: "translate(0,0)"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968C80",
    transform: "translate(0,0)"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988B74",
    transform: "translate(0,0)"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7885F",
    transform: "translate(0,0)"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9860",
    transform: "translate(0,0)"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89668",
    transform: "translate(0,0)"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA1",
    transform: "translate(0,0)"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918F",
    transform: "translate(0,0)"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969691",
    transform: "translate(0,0)"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949592",
    transform: "translate(0,0)"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918E",
    transform: "translate(0,0)"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959086",
    transform: "translate(0,0)"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C09152",
    transform: "translate(0,0)"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4A224",
    transform: "translate(0,0)"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE9760",
    transform: "translate(0,0)"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F85",
    transform: "translate(0,0)"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D7F",
    transform: "translate(0,0)"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E7F",
    transform: "translate(0,0)"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7E",
    transform: "translate(0,0)"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8B73",
    transform: "translate(0,0)"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E886B",
    transform: "translate(0,0)"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975D",
    transform: "translate(0,0)"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09D",
    transform: "translate(0,0)"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959185",
    transform: "translate(0,0)"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7C",
    transform: "translate(0,0)"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8B73",
    transform: "translate(0,0)"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A2",
    transform: "translate(0,0)"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959390",
    transform: "translate(0,0)"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938D",
    transform: "translate(0,0)"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E85",
    transform: "translate(0,0)"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978B7D",
    transform: "translate(0,0)"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998A73",
    transform: "translate(0,0)"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8B5B",
    transform: "translate(0,0)"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C09760",
    transform: "translate(0,0)"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9281",
    transform: "translate(0,0)"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968A78",
    transform: "translate(0,0)"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979592",
    transform: "translate(0,0)"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939388",
    transform: "translate(0,0)"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969084",
    transform: "translate(0,0)"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E7E",
    transform: "translate(0,0)"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8A70",
    transform: "translate(0,0)"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939591",
    transform: "translate(0,0)"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91938E",
    transform: "translate(0,0)"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F85",
    transform: "translate(0,0)"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8B71",
    transform: "translate(0,0)"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8B6F",
    transform: "translate(0,0)"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0985E",
    transform: "translate(0,0)"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A98",
    transform: "translate(0,0)"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8D76",
    transform: "translate(0,0)"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8A6B",
    transform: "translate(0,0)"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F09F25",
    transform: "translate(0,0)"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9B",
    transform: "translate(0,0)"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A4",
    transform: "translate(0,0)"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09FA1",
    transform: "translate(0,0)"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918D",
    transform: "translate(0,0)"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E82",
    transform: "translate(0,0)"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC9E2B",
    transform: "translate(0,0)"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2995E",
    transform: "translate(0,0)"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9389",
    transform: "translate(0,0)"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978B75",
    transform: "translate(0,0)"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959793",
    transform: "translate(0,0)"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F83",
    transform: "translate(0,0)"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8B70",
    transform: "translate(0,0)"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A323",
    transform: "translate(0,0)"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9D",
    transform: "translate(0,0)"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9385",
    transform: "translate(0,0)"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959590",
    transform: "translate(0,0)"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928E",
    transform: "translate(0,0)"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928A",
    transform: "translate(0,0)"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928C",
    transform: "translate(0,0)"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928D",
    transform: "translate(0,0)"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F84",
    transform: "translate(0,0)"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968E82",
    transform: "translate(0,0)"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8B70",
    transform: "translate(0,0)"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978C7A",
    transform: "translate(0,0)"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969996",
    transform: "translate(0,0)"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988D7A",
    transform: "translate(0,0)"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98989A",
    transform: "translate(0,0)"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978D7E",
    transform: "translate(0,0)"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18968",
    transform: "translate(0,0)"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE8C5A",
    transform: "translate(0,0)"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B38C55",
    transform: "translate(0,0)"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB8F52",
    transform: "translate(0,0)"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985E",
    transform: "translate(0,0)"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998B73",
    transform: "translate(0,0)"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959590",
    transform: "translate(0,0)"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949185",
    transform: "translate(0,0)"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EEA129",
    transform: "translate(0,0)"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999591",
    transform: "translate(0,0)"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939693",
    transform: "translate(0,0)"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8C74",
    transform: "translate(0,0)"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8A6C",
    transform: "translate(0,0)"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985B",
    transform: "translate(0,0)"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928F",
    transform: "translate(0,0)"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928D",
    transform: "translate(0,0)"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928B",
    transform: "translate(0,0)"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E82",
    transform: "translate(0,0)"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E81",
    transform: "translate(0,0)"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8B6C",
    transform: "translate(0,0)"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3A225",
    transform: "translate(0,0)"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979081",
    transform: "translate(0,0)"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8D78",
    transform: "translate(0,0)"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28C6B",
    transform: "translate(0,0)"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38B67",
    transform: "translate(0,0)"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928E",
    transform: "translate(0,0)"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8A6B",
    transform: "translate(0,0)"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B68D54",
    transform: "translate(0,0)"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3995C",
    transform: "translate(0,0)"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99664",
    transform: "translate(0,0)"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9C9E",
    transform: "translate(0,0)"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979697",
    transform: "translate(0,0)"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F81",
    transform: "translate(0,0)"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8D76",
    transform: "translate(0,0)"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B68B54",
    transform: "translate(0,0)"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A524",
    transform: "translate(0,0)"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A1",
    transform: "translate(0,0)"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959692",
    transform: "translate(0,0)"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918C",
    transform: "translate(0,0)"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918A",
    transform: "translate(0,0)"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988C7A",
    transform: "translate(0,0)"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58C66",
    transform: "translate(0,0)"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8C78",
    transform: "translate(0,0)"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0985A",
    transform: "translate(0,0)"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969080",
    transform: "translate(0,0)"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8D76",
    transform: "translate(0,0)"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989697",
    transform: "translate(0,0)"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969491",
    transform: "translate(0,0)"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938D",
    transform: "translate(0,0)"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8D78",
    transform: "translate(0,0)"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28A68",
    transform: "translate(0,0)"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8B6F",
    transform: "translate(0,0)"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959690",
    transform: "translate(0,0)"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F7F",
    transform: "translate(0,0)"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8C75",
    transform: "translate(0,0)"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969693",
    transform: "translate(0,0)"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939390",
    transform: "translate(0,0)"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949189",
    transform: "translate(0,0)"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978D7F",
    transform: "translate(0,0)"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988C79",
    transform: "translate(0,0)"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8C75",
    transform: "translate(0,0)"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58C66",
    transform: "translate(0,0)"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D49842",
    transform: "translate(0,0)"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE975E",
    transform: "translate(0,0)"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975C",
    transform: "translate(0,0)"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99907E",
    transform: "translate(0,0)"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7C",
    transform: "translate(0,0)"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A3",
    transform: "translate(0,0)"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989896",
    transform: "translate(0,0)"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969595",
    transform: "translate(0,0)"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938D",
    transform: "translate(0,0)"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985D",
    transform: "translate(0,0)"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999288",
    transform: "translate(0,0)"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9C",
    transform: "translate(0,0)"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94908C",
    transform: "translate(0,0)"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979695",
    transform: "translate(0,0)"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988E7D",
    transform: "translate(0,0)"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8C72",
    transform: "translate(0,0)"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28C6E",
    transform: "translate(0,0)"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A222",
    transform: "translate(0,0)"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959087",
    transform: "translate(0,0)"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC8E60",
    transform: "translate(0,0)"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949088",
    transform: "translate(0,0)"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F82",
    transform: "translate(0,0)"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988E7D",
    transform: "translate(0,0)"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8D73",
    transform: "translate(0,0)"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28E6B",
    transform: "translate(0,0)"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78D64",
    transform: "translate(0,0)"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC8D61",
    transform: "translate(0,0)"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB983E",
    transform: "translate(0,0)"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8D72",
    transform: "translate(0,0)"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18C6F",
    transform: "translate(0,0)"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959894",
    transform: "translate(0,0)"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08E73",
    transform: "translate(0,0)"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE8D5E",
    transform: "translate(0,0)"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9A",
    transform: "translate(0,0)"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928C",
    transform: "translate(0,0)"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D7C",
    transform: "translate(0,0)"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48D6A",
    transform: "translate(0,0)"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A98D64",
    transform: "translate(0,0)"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4995C",
    transform: "translate(0,0)"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9285",
    transform: "translate(0,0)"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9A",
    transform: "translate(0,0)"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938D",
    transform: "translate(0,0)"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7C",
    transform: "translate(0,0)"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48E6B",
    transform: "translate(0,0)"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD956E",
    transform: "translate(0,0)"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979086",
    transform: "translate(0,0)"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F85",
    transform: "translate(0,0)"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979695",
    transform: "translate(0,0)"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7C",
    transform: "translate(0,0)"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8C63",
    transform: "translate(0,0)"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B28E5C",
    transform: "translate(0,0)"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8E71",
    transform: "translate(0,0)"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1965B",
    transform: "translate(0,0)"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959085",
    transform: "translate(0,0)"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8E78",
    transform: "translate(0,0)"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18E70",
    transform: "translate(0,0)"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38E6D",
    transform: "translate(0,0)"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD8F61",
    transform: "translate(0,0)"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A99",
    transform: "translate(0,0)"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969187",
    transform: "translate(0,0)"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7B",
    transform: "translate(0,0)"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18C71",
    transform: "translate(0,0)"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8D60",
    transform: "translate(0,0)"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4985C",
    transform: "translate(0,0)"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9563",
    transform: "translate(0,0)"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19279",
    transform: "translate(0,0)"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9285",
    transform: "translate(0,0)"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969594",
    transform: "translate(0,0)"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948F",
    transform: "translate(0,0)"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928C",
    transform: "translate(0,0)"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28C6F",
    transform: "translate(0,0)"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A322",
    transform: "translate(0,0)"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9187",
    transform: "translate(0,0)"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F85",
    transform: "translate(0,0)"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985A",
    transform: "translate(0,0)"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938B",
    transform: "translate(0,0)"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F84",
    transform: "translate(0,0)"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8E7A",
    transform: "translate(0,0)"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF8E5F",
    transform: "translate(0,0)"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF985C",
    transform: "translate(0,0)"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989185",
    transform: "translate(0,0)"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969794",
    transform: "translate(0,0)"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948D",
    transform: "translate(0,0)"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B98",
    transform: "translate(0,0)"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989289",
    transform: "translate(0,0)"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8E7A",
    transform: "translate(0,0)"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4995B",
    transform: "translate(0,0)"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9662",
    transform: "translate(0,0)"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9385",
    transform: "translate(0,0)"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09D",
    transform: "translate(0,0)"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A3",
    transform: "translate(0,0)"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969593",
    transform: "translate(0,0)"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938D",
    transform: "translate(0,0)"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8E78",
    transform: "translate(0,0)"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989084",
    transform: "translate(0,0)"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48C6B",
    transform: "translate(0,0)"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938C",
    transform: "translate(0,0)"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918B",
    transform: "translate(0,0)"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8D79",
    transform: "translate(0,0)"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8D77",
    transform: "translate(0,0)"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8F64",
    transform: "translate(0,0)"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B38F5B",
    transform: "translate(0,0)"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3A221",
    transform: "translate(0,0)"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989081",
    transform: "translate(0,0)"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38D6C",
    transform: "translate(0,0)"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48D6E",
    transform: "translate(0,0)"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F84",
    transform: "translate(0,0)"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F77",
    transform: "translate(0,0)"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78E6C",
    transform: "translate(0,0)"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9A",
    transform: "translate(0,0)"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9C",
    transform: "translate(0,0)"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989188",
    transform: "translate(0,0)"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7D",
    transform: "translate(0,0)"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8C77",
    transform: "translate(0,0)"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9079",
    transform: "translate(0,0)"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B38F5B",
    transform: "translate(0,0)"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4985C",
    transform: "translate(0,0)"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9763",
    transform: "translate(0,0)"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F83",
    transform: "translate(0,0)"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979592",
    transform: "translate(0,0)"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96958C",
    transform: "translate(0,0)"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948C",
    transform: "translate(0,0)"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F76",
    transform: "translate(0,0)"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68D6B",
    transform: "translate(0,0)"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78E6A",
    transform: "translate(0,0)"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD8F63",
    transform: "translate(0,0)"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9C",
    transform: "translate(0,0)"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998E81",
    transform: "translate(0,0)"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09D",
    transform: "translate(0,0)"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938C",
    transform: "translate(0,0)"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979082",
    transform: "translate(0,0)"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7F",
    transform: "translate(0,0)"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8D77",
    transform: "translate(0,0)"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69059",
    transform: "translate(0,0)"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58E69",
    transform: "translate(0,0)"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985A",
    transform: "translate(0,0)"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A88D68",
    transform: "translate(0,0)"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938C",
    transform: "translate(0,0)"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F76",
    transform: "translate(0,0)"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999999",
    transform: "translate(0,0)"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979088",
    transform: "translate(0,0)"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F76",
    transform: "translate(0,0)"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B79157",
    transform: "translate(0,0)"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985B",
    transform: "translate(0,0)"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9EA1",
    transform: "translate(0,0)"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928B",
    transform: "translate(0,0)"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08E75",
    transform: "translate(0,0)"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78F6A",
    transform: "translate(0,0)"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE946E",
    transform: "translate(0,0)"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928A",
    transform: "translate(0,0)"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998E81",
    transform: "translate(0,0)"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A2",
    transform: "translate(0,0)"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959693",
    transform: "translate(0,0)"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938B",
    transform: "translate(0,0)"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08E75",
    transform: "translate(0,0)"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99156",
    transform: "translate(0,0)"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A907F",
    transform: "translate(0,0)"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78D67",
    transform: "translate(0,0)"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8E68",
    transform: "translate(0,0)"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09D",
    transform: "translate(0,0)"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969693",
    transform: "translate(0,0)"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949492",
    transform: "translate(0,0)"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979285",
    transform: "translate(0,0)"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09076",
    transform: "translate(0,0)"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979186",
    transform: "translate(0,0)"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8D74",
    transform: "translate(0,0)"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4975B",
    transform: "translate(0,0)"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A3",
    transform: "translate(0,0)"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A2",
    transform: "translate(0,0)"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8D67",
    transform: "translate(0,0)"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959391",
    transform: "translate(0,0)"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998F81",
    transform: "translate(0,0)"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A98E66",
    transform: "translate(0,0)"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8E66",
    transform: "translate(0,0)"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9D9B",
    transform: "translate(0,0)"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19E",
    transform: "translate(0,0)"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928A",
    transform: "translate(0,0)"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969287",
    transform: "translate(0,0)"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F75",
    transform: "translate(0,0)"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9153",
    transform: "translate(0,0)"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9180",
    transform: "translate(0,0)"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8E66",
    transform: "translate(0,0)"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC8E67",
    transform: "translate(0,0)"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3905E",
    transform: "translate(0,0)"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1965A",
    transform: "translate(0,0)"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959691",
    transform: "translate(0,0)"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918A",
    transform: "translate(0,0)"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39073",
    transform: "translate(0,0)"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C99",
    transform: "translate(0,0)"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989087",
    transform: "translate(0,0)"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9251",
    transform: "translate(0,0)"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4985C",
    transform: "translate(0,0)"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9662",
    transform: "translate(0,0)"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959693",
    transform: "translate(0,0)"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948A",
    transform: "translate(0,0)"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8E7F",
    transform: "translate(0,0)"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8F6A",
    transform: "translate(0,0)"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE8F63",
    transform: "translate(0,0)"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2975A",
    transform: "translate(0,0)"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979289",
    transform: "translate(0,0)"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9D9D",
    transform: "translate(0,0)"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F7E",
    transform: "translate(0,0)"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA1",
    transform: "translate(0,0)"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969492",
    transform: "translate(0,0)"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928A",
    transform: "translate(0,0)"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989186",
    transform: "translate(0,0)"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F83",
    transform: "translate(0,0)"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B907E",
    transform: "translate(0,0)"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8E79",
    transform: "translate(0,0)"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28E73",
    transform: "translate(0,0)"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48F71",
    transform: "translate(0,0)"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A98E68",
    transform: "translate(0,0)"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE9164",
    transform: "translate(0,0)"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2934F",
    transform: "translate(0,0)"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949590",
    transform: "translate(0,0)"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918B",
    transform: "translate(0,0)"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999185",
    transform: "translate(0,0)"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9181",
    transform: "translate(0,0)"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1944F",
    transform: "translate(0,0)"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC9644",
    transform: "translate(0,0)"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985D",
    transform: "translate(0,0)"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9763",
    transform: "translate(0,0)"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9286",
    transform: "translate(0,0)"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9B",
    transform: "translate(0,0)"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9E",
    transform: "translate(0,0)"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959792",
    transform: "translate(0,0)"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948A",
    transform: "translate(0,0)"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928A",
    transform: "translate(0,0)"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969087",
    transform: "translate(0,0)"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F78",
    transform: "translate(0,0)"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4A423",
    transform: "translate(0,0)"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C927F",
    transform: "translate(0,0)"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9D",
    transform: "translate(0,0)"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B907E",
    transform: "translate(0,0)"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19E",
    transform: "translate(0,0)"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979187",
    transform: "translate(0,0)"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999083",
    transform: "translate(0,0)"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B907E",
    transform: "translate(0,0)"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49071",
    transform: "translate(0,0)"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58F70",
    transform: "translate(0,0)"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C6944E",
    transform: "translate(0,0)"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D917E",
    transform: "translate(0,0)"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE8F63",
    transform: "translate(0,0)"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0965C",
    transform: "translate(0,0)"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969690",
    transform: "translate(0,0)"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9B",
    transform: "translate(0,0)"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A2",
    transform: "translate(0,0)"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999898",
    transform: "translate(0,0)"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9184",
    transform: "translate(0,0)"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38E71",
    transform: "translate(0,0)"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C6954B",
    transform: "translate(0,0)"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985D",
    transform: "translate(0,0)"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9762",
    transform: "translate(0,0)"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95948F",
    transform: "translate(0,0)"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979389",
    transform: "translate(0,0)"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD8F67",
    transform: "translate(0,0)"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949089",
    transform: "translate(0,0)"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999087",
    transform: "translate(0,0)"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989082",
    transform: "translate(0,0)"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F7D",
    transform: "translate(0,0)"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58F71",
    transform: "translate(0,0)"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49260",
    transform: "translate(0,0)"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B98",
    transform: "translate(0,0)"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969690",
    transform: "translate(0,0)"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6A122",
    transform: "translate(0,0)"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959691",
    transform: "translate(0,0)"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948F",
    transform: "translate(0,0)"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7926F",
    transform: "translate(0,0)"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F09D22",
    transform: "translate(0,0)"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F49F20",
    transform: "translate(0,0)"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9A",
    transform: "translate(0,0)"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19E",
    transform: "translate(0,0)"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9999",
    transform: "translate(0,0)"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999896",
    transform: "translate(0,0)"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969593",
    transform: "translate(0,0)"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969390",
    transform: "translate(0,0)"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97918A",
    transform: "translate(0,0)"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9183",
    transform: "translate(0,0)"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68E6E",
    transform: "translate(0,0)"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F59F22",
    transform: "translate(0,0)"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2975C",
    transform: "translate(0,0)"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999385",
    transform: "translate(0,0)"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948F",
    transform: "translate(0,0)"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928F",
    transform: "translate(0,0)"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7916E",
    transform: "translate(0,0)"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E907C",
    transform: "translate(0,0)"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7925F",
    transform: "translate(0,0)"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29E",
    transform: "translate(0,0)"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969087",
    transform: "translate(0,0)"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917C",
    transform: "translate(0,0)"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F7D",
    transform: "translate(0,0)"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7906E",
    transform: "translate(0,0)"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD9745",
    transform: "translate(0,0)"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF965A",
    transform: "translate(0,0)"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8916F",
    transform: "translate(0,0)"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1A42E",
    transform: "translate(0,0)"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C99",
    transform: "translate(0,0)"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999289",
    transform: "translate(0,0)"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9184",
    transform: "translate(0,0)"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9916F",
    transform: "translate(0,0)"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE9846",
    transform: "translate(0,0)"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985E",
    transform: "translate(0,0)"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999284",
    transform: "translate(0,0)"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89260",
    transform: "translate(0,0)"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989388",
    transform: "translate(0,0)"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E907C",
    transform: "translate(0,0)"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9906E",
    transform: "translate(0,0)"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8935D",
    transform: "translate(0,0)"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EBA12C",
    transform: "translate(0,0)"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A79273",
    transform: "translate(0,0)"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989289",
    transform: "translate(0,0)"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19E",
    transform: "translate(0,0)"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8935D",
    transform: "translate(0,0)"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1975C",
    transform: "translate(0,0)"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19E",
    transform: "translate(0,0)"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999186",
    transform: "translate(0,0)"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9080",
    transform: "translate(0,0)"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7906D",
    transform: "translate(0,0)"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9181",
    transform: "translate(0,0)"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926A",
    transform: "translate(0,0)"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29262",
    transform: "translate(0,0)"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96918A",
    transform: "translate(0,0)"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989387",
    transform: "translate(0,0)"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D29942",
    transform: "translate(0,0)"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975F",
    transform: "translate(0,0)"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9C",
    transform: "translate(0,0)"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989388",
    transform: "translate(0,0)"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9916D",
    transform: "translate(0,0)"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9945D",
    transform: "translate(0,0)"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A3",
    transform: "translate(0,0)"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917A",
    transform: "translate(0,0)"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29E",
    transform: "translate(0,0)"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969287",
    transform: "translate(0,0)"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979287",
    transform: "translate(0,0)"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F85",
    transform: "translate(0,0)"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9906D",
    transform: "translate(0,0)"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D69A40",
    transform: "translate(0,0)"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF975D",
    transform: "translate(0,0)"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC975E",
    transform: "translate(0,0)"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969B99",
    transform: "translate(0,0)"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19E",
    transform: "translate(0,0)"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948F",
    transform: "translate(0,0)"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D917F",
    transform: "translate(0,0)"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE9168",
    transform: "translate(0,0)"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA9E2B",
    transform: "translate(0,0)"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9C",
    transform: "translate(0,0)"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A0",
    transform: "translate(0,0)"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948D",
    transform: "translate(0,0)"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9082",
    transform: "translate(0,0)"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D79A3F",
    transform: "translate(0,0)"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE975E",
    transform: "translate(0,0)"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969493",
    transform: "translate(0,0)"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999186",
    transform: "translate(0,0)"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA916C",
    transform: "translate(0,0)"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9945D",
    transform: "translate(0,0)"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC925B",
    transform: "translate(0,0)"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9D9C",
    transform: "translate(0,0)"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959390",
    transform: "translate(0,0)"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F7A",
    transform: "translate(0,0)"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969287",
    transform: "translate(0,0)"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9184",
    transform: "translate(0,0)"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39174",
    transform: "translate(0,0)"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA916C",
    transform: "translate(0,0)"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19E",
    transform: "translate(0,0)"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948F",
    transform: "translate(0,0)"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948E",
    transform: "translate(0,0)"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926C",
    transform: "translate(0,0)"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3A425",
    transform: "translate(0,0)"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A2",
    transform: "translate(0,0)"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9D",
    transform: "translate(0,0)"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959492",
    transform: "translate(0,0)"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9081",
    transform: "translate(0,0)"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8F6C",
    transform: "translate(0,0)"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC926D",
    transform: "translate(0,0)"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DB9C38",
    transform: "translate(0,0)"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF975E",
    transform: "translate(0,0)"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989085",
    transform: "translate(0,0)"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A2",
    transform: "translate(0,0)"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A023",
    transform: "translate(0,0)"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928E",
    transform: "translate(0,0)"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F7B",
    transform: "translate(0,0)"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39074",
    transform: "translate(0,0)"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC916C",
    transform: "translate(0,0)"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9459",
    transform: "translate(0,0)"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC965E",
    transform: "translate(0,0)"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907A",
    transform: "translate(0,0)"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE9557",
    transform: "translate(0,0)"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19E",
    transform: "translate(0,0)"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969287",
    transform: "translate(0,0)"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39073",
    transform: "translate(0,0)"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926C",
    transform: "translate(0,0)"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E19C38",
    transform: "translate(0,0)"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC955E",
    transform: "translate(0,0)"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9C",
    transform: "translate(0,0)"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB936B",
    transform: "translate(0,0)"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A3",
    transform: "translate(0,0)"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9D",
    transform: "translate(0,0)"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989797",
    transform: "translate(0,0)"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA906A",
    transform: "translate(0,0)"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E19D35",
    transform: "translate(0,0)"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE9760",
    transform: "translate(0,0)"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949490",
    transform: "translate(0,0)"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928F",
    transform: "translate(0,0)"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907A",
    transform: "translate(0,0)"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39073",
    transform: "translate(0,0)"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926B",
    transform: "translate(0,0)"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA39F",
    transform: "translate(0,0)"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979186",
    transform: "translate(0,0)"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C907E",
    transform: "translate(0,0)"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB916B",
    transform: "translate(0,0)"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E49D34",
    transform: "translate(0,0)"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9660",
    transform: "translate(0,0)"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19557",
    transform: "translate(0,0)"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE984B",
    transform: "translate(0,0)"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938F",
    transform: "translate(0,0)"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9181",
    transform: "translate(0,0)"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E69E30",
    transform: "translate(0,0)"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE975F",
    transform: "translate(0,0)"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE926A",
    transform: "translate(0,0)"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19556",
    transform: "translate(0,0)"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989286",
    transform: "translate(0,0)"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9183",
    transform: "translate(0,0)"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC926A",
    transform: "translate(0,0)"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA9C28",
    transform: "translate(0,0)"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09E",
    transform: "translate(0,0)"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A98",
    transform: "translate(0,0)"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959590",
    transform: "translate(0,0)"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928C",
    transform: "translate(0,0)"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9280",
    transform: "translate(0,0)"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49553",
    transform: "translate(0,0)"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E99E28",
    transform: "translate(0,0)"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF975F",
    transform: "translate(0,0)"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9C",
    transform: "translate(0,0)"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928E",
    transform: "translate(0,0)"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59171",
    transform: "translate(0,0)"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19656",
    transform: "translate(0,0)"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09E",
    transform: "translate(0,0)"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938B",
    transform: "translate(0,0)"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A5A3",
    transform: "translate(0,0)"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979285",
    transform: "translate(0,0)"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1907A",
    transform: "translate(0,0)"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69172",
    transform: "translate(0,0)"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE916A",
    transform: "translate(0,0)"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49755",
    transform: "translate(0,0)"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD975E",
    transform: "translate(0,0)"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29178",
    transform: "translate(0,0)"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948D",
    transform: "translate(0,0)"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D917E",
    transform: "translate(0,0)"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9368",
    transform: "translate(0,0)"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B99",
    transform: "translate(0,0)"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A2",
    transform: "translate(0,0)"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A999B",
    transform: "translate(0,0)"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969491",
    transform: "translate(0,0)"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9180",
    transform: "translate(0,0)"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9369",
    transform: "translate(0,0)"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF985D",
    transform: "translate(0,0)"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF926A",
    transform: "translate(0,0)"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959492",
    transform: "translate(0,0)"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39078",
    transform: "translate(0,0)"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69271",
    transform: "translate(0,0)"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9369",
    transform: "translate(0,0)"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF985D",
    transform: "translate(0,0)"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938B",
    transform: "translate(0,0)"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979284",
    transform: "translate(0,0)"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9181",
    transform: "translate(0,0)"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29079",
    transform: "translate(0,0)"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE9269",
    transform: "translate(0,0)"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC975F",
    transform: "translate(0,0)"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29378",
    transform: "translate(0,0)"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C39552",
    transform: "translate(0,0)"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938D",
    transform: "translate(0,0)"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09468",
    transform: "translate(0,0)"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB955D",
    transform: "translate(0,0)"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB9C2B",
    transform: "translate(0,0)"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999087",
    transform: "translate(0,0)"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D917F",
    transform: "translate(0,0)"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975E",
    transform: "translate(0,0)"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938F",
    transform: "translate(0,0)"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918E",
    transform: "translate(0,0)"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD936D",
    transform: "translate(0,0)"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9183",
    transform: "translate(0,0)"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49077",
    transform: "translate(0,0)"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A79170",
    transform: "translate(0,0)"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09268",
    transform: "translate(0,0)"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD955C",
    transform: "translate(0,0)"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C59751",
    transform: "translate(0,0)"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE975C",
    transform: "translate(0,0)"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989895",
    transform: "translate(0,0)"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9082",
    transform: "translate(0,0)"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39177",
    transform: "translate(0,0)"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9267",
    transform: "translate(0,0)"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD975E",
    transform: "translate(0,0)"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE965C",
    transform: "translate(0,0)"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9B",
    transform: "translate(0,0)"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948E",
    transform: "translate(0,0)"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999185",
    transform: "translate(0,0)"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19467",
    transform: "translate(0,0)"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8A31C",
    transform: "translate(0,0)"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EEA030",
    transform: "translate(0,0)"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9B",
    transform: "translate(0,0)"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938C",
    transform: "translate(0,0)"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09168",
    transform: "translate(0,0)"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9660",
    transform: "translate(0,0)"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99464",
    transform: "translate(0,0)"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948A",
    transform: "translate(0,0)"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39277",
    transform: "translate(0,0)"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29468",
    transform: "translate(0,0)"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C89850",
    transform: "translate(0,0)"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A11F",
    transform: "translate(0,0)"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C9974C",
    transform: "translate(0,0)"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9182",
    transform: "translate(0,0)"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09367",
    transform: "translate(0,0)"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975C",
    transform: "translate(0,0)"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA974E",
    transform: "translate(0,0)"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6A01E",
    transform: "translate(0,0)"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96958E",
    transform: "translate(0,0)"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999385",
    transform: "translate(0,0)"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29466",
    transform: "translate(0,0)"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9A",
    transform: "translate(0,0)"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989897",
    transform: "translate(0,0)"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917F",
    transform: "translate(0,0)"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A99170",
    transform: "translate(0,0)"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19166",
    transform: "translate(0,0)"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29466",
    transform: "translate(0,0)"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985E",
    transform: "translate(0,0)"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9084",
    transform: "translate(0,0)"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938C",
    transform: "translate(0,0)"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999385",
    transform: "translate(0,0)"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39466",
    transform: "translate(0,0)"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C99850",
    transform: "translate(0,0)"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC984E",
    transform: "translate(0,0)"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9282",
    transform: "translate(0,0)"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917D",
    transform: "translate(0,0)"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39179",
    transform: "translate(0,0)"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39277",
    transform: "translate(0,0)"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19266",
    transform: "translate(0,0)"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB994E",
    transform: "translate(0,0)"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF9B4E",
    transform: "translate(0,0)"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF985F",
    transform: "translate(0,0)"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C79750",
    transform: "translate(0,0)"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF965C",
    transform: "translate(0,0)"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938D",
    transform: "translate(0,0)"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49466",
    transform: "translate(0,0)"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A3",
    transform: "translate(0,0)"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989896",
    transform: "translate(0,0)"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989795",
    transform: "translate(0,0)"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938E",
    transform: "translate(0,0)"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98938B",
    transform: "translate(0,0)"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49467",
    transform: "translate(0,0)"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985D",
    transform: "translate(0,0)"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9663",
    transform: "translate(0,0)"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A2",
    transform: "translate(0,0)"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928E",
    transform: "translate(0,0)"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39367",
    transform: "translate(0,0)"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC994C",
    transform: "translate(0,0)"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1985B",
    transform: "translate(0,0)"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999184",
    transform: "translate(0,0)"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9280",
    transform: "translate(0,0)"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E907D",
    transform: "translate(0,0)"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19366",
    transform: "translate(0,0)"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D19B4D",
    transform: "translate(0,0)"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948D",
    transform: "translate(0,0)"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948D",
    transform: "translate(0,0)"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49565",
    transform: "translate(0,0)"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999187",
    transform: "translate(0,0)"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917F",
    transform: "translate(0,0)"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49465",
    transform: "translate(0,0)"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3975B",
    transform: "translate(0,0)"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917C",
    transform: "translate(0,0)"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938D",
    transform: "translate(0,0)"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975D",
    transform: "translate(0,0)"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49276",
    transform: "translate(0,0)"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89270",
    transform: "translate(0,0)"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE9949",
    transform: "translate(0,0)"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59176",
    transform: "translate(0,0)"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A3",
    transform: "translate(0,0)"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9180",
    transform: "translate(0,0)"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917F",
    transform: "translate(0,0)"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917C",
    transform: "translate(0,0)"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59178",
    transform: "translate(0,0)"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39466",
    transform: "translate(0,0)"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE974B",
    transform: "translate(0,0)"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96958E",
    transform: "translate(0,0)"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49565",
    transform: "translate(0,0)"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A0",
    transform: "translate(0,0)"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917D",
    transform: "translate(0,0)"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39264",
    transform: "translate(0,0)"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3975B",
    transform: "translate(0,0)"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9C",
    transform: "translate(0,0)"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59465",
    transform: "translate(0,0)"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD984B",
    transform: "translate(0,0)"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49277",
    transform: "translate(0,0)"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C39859",
    transform: "translate(0,0)"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49466",
    transform: "translate(0,0)"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19556",
    transform: "translate(0,0)"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB936F",
    transform: "translate(0,0)"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7A523",
    transform: "translate(0,0)"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938D",
    transform: "translate(0,0)"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959590",
    transform: "translate(0,0)"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0927E",
    transform: "translate(0,0)"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69566",
    transform: "translate(0,0)"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2985B",
    transform: "translate(0,0)"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979391",
    transform: "translate(0,0)"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948D",
    transform: "translate(0,0)"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69075",
    transform: "translate(0,0)"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69176",
    transform: "translate(0,0)"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59465",
    transform: "translate(0,0)"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A323",
    transform: "translate(0,0)"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985A",
    transform: "translate(0,0)"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9D",
    transform: "translate(0,0)"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979185",
    transform: "translate(0,0)"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9181",
    transform: "translate(0,0)"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69275",
    transform: "translate(0,0)"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC936F",
    transform: "translate(0,0)"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39465",
    transform: "translate(0,0)"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97979A",
    transform: "translate(0,0)"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F937C",
    transform: "translate(0,0)"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59565",
    transform: "translate(0,0)"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9A",
    transform: "translate(0,0)"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959391",
    transform: "translate(0,0)"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928F",
    transform: "translate(0,0)"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9287",
    transform: "translate(0,0)"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917F",
    transform: "translate(0,0)"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49365",
    transform: "translate(0,0)"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4995C",
    transform: "translate(0,0)"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969492",
    transform: "translate(0,0)"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69565",
    transform: "translate(0,0)"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4A323",
    transform: "translate(0,0)"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989284",
    transform: "translate(0,0)"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49277",
    transform: "translate(0,0)"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49465",
    transform: "translate(0,0)"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0985C",
    transform: "translate(0,0)"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975A",
    transform: "translate(0,0)"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999285",
    transform: "translate(0,0)"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19658",
    transform: "translate(0,0)"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99665",
    transform: "translate(0,0)"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979490",
    transform: "translate(0,0)"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F927F",
    transform: "translate(0,0)"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985B",
    transform: "translate(0,0)"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9662",
    transform: "translate(0,0)"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49076",
    transform: "translate(0,0)"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98928C",
    transform: "translate(0,0)"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9385",
    transform: "translate(0,0)"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9285",
    transform: "translate(0,0)"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69564",
    transform: "translate(0,0)"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE994C",
    transform: "translate(0,0)"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E9F",
    transform: "translate(0,0)"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A0",
    transform: "translate(0,0)"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59176",
    transform: "translate(0,0)"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989283",
    transform: "translate(0,0)"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999184",
    transform: "translate(0,0)"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9180",
    transform: "translate(0,0)"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69276",
    transform: "translate(0,0)"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49464",
    transform: "translate(0,0)"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958F",
    transform: "translate(0,0)"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989186",
    transform: "translate(0,0)"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69565",
    transform: "translate(0,0)"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9382",
    transform: "translate(0,0)"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9B",
    transform: "translate(0,0)"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F937F",
    transform: "translate(0,0)"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985C",
    transform: "translate(0,0)"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59378",
    transform: "translate(0,0)"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969491",
    transform: "translate(0,0)"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69464",
    transform: "translate(0,0)"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF9A4B",
    transform: "translate(0,0)"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999185",
    transform: "translate(0,0)"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC926E",
    transform: "translate(0,0)"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49465",
    transform: "translate(0,0)"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CC984C",
    transform: "translate(0,0)"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958F",
    transform: "translate(0,0)"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E927C",
    transform: "translate(0,0)"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59664",
    transform: "translate(0,0)"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A2",
    transform: "translate(0,0)"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9287",
    transform: "translate(0,0)"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F927F",
    transform: "translate(0,0)"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6A31F",
    transform: "translate(0,0)"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2995C",
    transform: "translate(0,0)"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9663",
    transform: "translate(0,0)"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9485",
    transform: "translate(0,0)"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69076",
    transform: "translate(0,0)"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59465",
    transform: "translate(0,0)"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989184",
    transform: "translate(0,0)"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917B",
    transform: "translate(0,0)"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59177",
    transform: "translate(0,0)"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49565",
    transform: "translate(0,0)"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69376",
    transform: "translate(0,0)"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB994B",
    transform: "translate(0,0)"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CF994A",
    transform: "translate(0,0)"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8A31F",
    transform: "translate(0,0)"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B99",
    transform: "translate(0,0)"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69564",
    transform: "translate(0,0)"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999696",
    transform: "translate(0,0)"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969491",
    transform: "translate(0,0)"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3985A",
    transform: "translate(0,0)"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9662",
    transform: "translate(0,0)"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969690",
    transform: "translate(0,0)"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98938D",
    transform: "translate(0,0)"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59464",
    transform: "translate(0,0)"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CD994C",
    transform: "translate(0,0)"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A6",
    transform: "translate(0,0)"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C29859",
    transform: "translate(0,0)"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9184",
    transform: "translate(0,0)"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49465",
    transform: "translate(0,0)"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59376",
    transform: "translate(0,0)"
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA994D",
    transform: "translate(0,0)"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE994C",
    transform: "translate(0,0)"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19659",
    transform: "translate(0,0)"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958E",
    transform: "translate(0,0)"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979491",
    transform: "translate(0,0)"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98948A",
    transform: "translate(0,0)"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59464",
    transform: "translate(0,0)"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2975B",
    transform: "translate(0,0)"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9185",
    transform: "translate(0,0)"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99938A",
    transform: "translate(0,0)"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59364",
    transform: "translate(0,0)"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF9E24",
    transform: "translate(0,0)"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9D",
    transform: "translate(0,0)"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9284",
    transform: "translate(0,0)"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69277",
    transform: "translate(0,0)"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49466",
    transform: "translate(0,0)"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAA41D",
    transform: "translate(0,0)"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBA61C",
    transform: "translate(0,0)"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97968E",
    transform: "translate(0,0)"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A4",
    transform: "translate(0,0)"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59565",
    transform: "translate(0,0)"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9C",
    transform: "translate(0,0)"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09D",
    transform: "translate(0,0)"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA3A1",
    transform: "translate(0,0)"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979490",
    transform: "translate(0,0)"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9180",
    transform: "translate(0,0)"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39265",
    transform: "translate(0,0)"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69565",
    transform: "translate(0,0)"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3965B",
    transform: "translate(0,0)"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A2",
    transform: "translate(0,0)"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9185",
    transform: "translate(0,0)"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949691",
    transform: "translate(0,0)"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98928D",
    transform: "translate(0,0)"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9283",
    transform: "translate(0,0)"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59276",
    transform: "translate(0,0)"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6A320",
    transform: "translate(0,0)"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9184",
    transform: "translate(0,0)"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9280",
    transform: "translate(0,0)"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39277",
    transform: "translate(0,0)"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB936F",
    transform: "translate(0,0)"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39466",
    transform: "translate(0,0)"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59377",
    transform: "translate(0,0)"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA29F",
    transform: "translate(0,0)"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948D",
    transform: "translate(0,0)"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999284",
    transform: "translate(0,0)"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39566",
    transform: "translate(0,0)"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989797",
    transform: "translate(0,0)"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99958A",
    transform: "translate(0,0)"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0927F",
    transform: "translate(0,0)"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19266",
    transform: "translate(0,0)"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39465",
    transform: "translate(0,0)"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1975C",
    transform: "translate(0,0)"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928C",
    transform: "translate(0,0)"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39367",
    transform: "translate(0,0)"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C8984F",
    transform: "translate(0,0)"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A320",
    transform: "translate(0,0)"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89272",
    transform: "translate(0,0)"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0985A",
    transform: "translate(0,0)"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA19F",
    transform: "translate(0,0)"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958E",
    transform: "translate(0,0)"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999384",
    transform: "translate(0,0)"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9184",
    transform: "translate(0,0)"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9181",
    transform: "translate(0,0)"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59278",
    transform: "translate(0,0)"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29367",
    transform: "translate(0,0)"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D19B48",
    transform: "translate(0,0)"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD975D",
    transform: "translate(0,0)"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928A",
    transform: "translate(0,0)"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE965A",
    transform: "translate(0,0)"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98948D",
    transform: "translate(0,0)"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969592",
    transform: "translate(0,0)"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948D",
    transform: "translate(0,0)"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9284",
    transform: "translate(0,0)"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F927D",
    transform: "translate(0,0)"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9C",
    transform: "translate(0,0)"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979591",
    transform: "translate(0,0)"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938B",
    transform: "translate(0,0)"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9280",
    transform: "translate(0,0)"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4927A",
    transform: "translate(0,0)"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49566",
    transform: "translate(0,0)"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3975B",
    transform: "translate(0,0)"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95948D",
    transform: "translate(0,0)"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9285",
    transform: "translate(0,0)"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39277",
    transform: "translate(0,0)"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49367",
    transform: "translate(0,0)"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C79750",
    transform: "translate(0,0)"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C9984E",
    transform: "translate(0,0)"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A4",
    transform: "translate(0,0)"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948F",
    transform: "translate(0,0)"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989183",
    transform: "translate(0,0)"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9081",
    transform: "translate(0,0)"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917C",
    transform: "translate(0,0)"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49279",
    transform: "translate(0,0)"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA9370",
    transform: "translate(0,0)"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89373",
    transform: "translate(0,0)"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29279",
    transform: "translate(0,0)"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0965A",
    transform: "translate(0,0)"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9D",
    transform: "translate(0,0)"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98968D",
    transform: "translate(0,0)"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A2",
    transform: "translate(0,0)"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917F",
    transform: "translate(0,0)"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49279",
    transform: "translate(0,0)"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19467",
    transform: "translate(0,0)"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1A025",
    transform: "translate(0,0)"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1975B",
    transform: "translate(0,0)"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89663",
    transform: "translate(0,0)"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2937D",
    transform: "translate(0,0)"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89470",
    transform: "translate(0,0)"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29467",
    transform: "translate(0,0)"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C79851",
    transform: "translate(0,0)"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C8994E",
    transform: "translate(0,0)"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1A125",
    transform: "translate(0,0)"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39178",
    transform: "translate(0,0)"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29179",
    transform: "translate(0,0)"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999284",
    transform: "translate(0,0)"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9381",
    transform: "translate(0,0)"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49075",
    transform: "translate(0,0)"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19368",
    transform: "translate(0,0)"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49851",
    transform: "translate(0,0)"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF965B",
    transform: "translate(0,0)"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938D",
    transform: "translate(0,0)"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9386",
    transform: "translate(0,0)"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89462",
    transform: "translate(0,0)"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9B",
    transform: "translate(0,0)"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979590",
    transform: "translate(0,0)"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9180",
    transform: "translate(0,0)"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECA028",
    transform: "translate(0,0)"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1975B",
    transform: "translate(0,0)"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B89562",
    transform: "translate(0,0)"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9D",
    transform: "translate(0,0)"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39368",
    transform: "translate(0,0)"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C89950",
    transform: "translate(0,0)"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5A31F",
    transform: "translate(0,0)"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A0",
    transform: "translate(0,0)"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999285",
    transform: "translate(0,0)"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA9171",
    transform: "translate(0,0)"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19469",
    transform: "translate(0,0)"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECA02B",
    transform: "translate(0,0)"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9AA09F",
    transform: "translate(0,0)"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958D",
    transform: "translate(0,0)"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989490",
    transform: "translate(0,0)"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98938C",
    transform: "translate(0,0)"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F917F",
    transform: "translate(0,0)"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3927B",
    transform: "translate(0,0)"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19369",
    transform: "translate(0,0)"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1975C",
    transform: "translate(0,0)"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B79464",
    transform: "translate(0,0)"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39178",
    transform: "translate(0,0)"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A2",
    transform: "translate(0,0)"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98948D",
    transform: "translate(0,0)"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938B",
    transform: "translate(0,0)"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39277",
    transform: "translate(0,0)"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09368",
    transform: "translate(0,0)"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49853",
    transform: "translate(0,0)"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29079",
    transform: "translate(0,0)"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999284",
    transform: "translate(0,0)"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49279",
    transform: "translate(0,0)"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09269",
    transform: "translate(0,0)"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD955A",
    transform: "translate(0,0)"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948F",
    transform: "translate(0,0)"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999285",
    transform: "translate(0,0)"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09468",
    transform: "translate(0,0)"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9A",
    transform: "translate(0,0)"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9286",
    transform: "translate(0,0)"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9280",
    transform: "translate(0,0)"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C0975E",
    transform: "translate(0,0)"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69466",
    transform: "translate(0,0)"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979389",
    transform: "translate(0,0)"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49178",
    transform: "translate(0,0)"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19855",
    transform: "translate(0,0)"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C49853",
    transform: "translate(0,0)"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A0",
    transform: "translate(0,0)"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989185",
    transform: "translate(0,0)"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9381",
    transform: "translate(0,0)"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE936A",
    transform: "translate(0,0)"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C29555",
    transform: "translate(0,0)"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96958E",
    transform: "translate(0,0)"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969490",
    transform: "translate(0,0)"
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969590",
    transform: "translate(0,0)"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928B",
    transform: "translate(0,0)"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9180",
    transform: "translate(0,0)"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE9369",
    transform: "translate(0,0)"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE9C36",
    transform: "translate(0,0)"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BE975E",
    transform: "translate(0,0)"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19279",
    transform: "translate(0,0)"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938D",
    transform: "translate(0,0)"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999485",
    transform: "translate(0,0)"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C19755",
    transform: "translate(0,0)"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2A426",
    transform: "translate(0,0)"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9C",
    transform: "translate(0,0)"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979185",
    transform: "translate(0,0)"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9183",
    transform: "translate(0,0)"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD926B",
    transform: "translate(0,0)"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD9C39",
    transform: "translate(0,0)"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB994F",
    transform: "translate(0,0)"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD9557",
    transform: "translate(0,0)"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA955F",
    transform: "translate(0,0)"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97948E",
    transform: "translate(0,0)"
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09FA1",
    transform: "translate(0,0)"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE946A",
    transform: "translate(0,0)"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C09656",
    transform: "translate(0,0)"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD9D3A",
    transform: "translate(0,0)"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A3",
    transform: "translate(0,0)"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9181",
    transform: "translate(0,0)"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC916A",
    transform: "translate(0,0)"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD936A",
    transform: "translate(0,0)"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D99C3A",
    transform: "translate(0,0)"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9560",
    transform: "translate(0,0)"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959893",
    transform: "translate(0,0)"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928E",
    transform: "translate(0,0)"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938E",
    transform: "translate(0,0)"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938B",
    transform: "translate(0,0)"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989385",
    transform: "translate(0,0)"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999384",
    transform: "translate(0,0)"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9183",
    transform: "translate(0,0)"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9179",
    transform: "translate(0,0)"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49272",
    transform: "translate(0,0)"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF9456",
    transform: "translate(0,0)"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CA994C",
    transform: "translate(0,0)"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F0A228",
    transform: "translate(0,0)"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949590",
    transform: "translate(0,0)"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979185",
    transform: "translate(0,0)"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989186",
    transform: "translate(0,0)"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9182",
    transform: "translate(0,0)"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D6993D",
    transform: "translate(0,0)"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C79851",
    transform: "translate(0,0)"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B79561",
    transform: "translate(0,0)"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98958F",
    transform: "translate(0,0)"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989187",
    transform: "translate(0,0)"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD936B",
    transform: "translate(0,0)"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989798",
    transform: "translate(0,0)"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979795",
    transform: "translate(0,0)"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969591",
    transform: "translate(0,0)"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948E",
    transform: "translate(0,0)"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9186",
    transform: "translate(0,0)"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9281",
    transform: "translate(0,0)"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0927C",
    transform: "translate(0,0)"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA916B",
    transform: "translate(0,0)"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D3993F",
    transform: "translate(0,0)"
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B99562",
    transform: "translate(0,0)"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B29469",
    transform: "translate(0,0)"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98928A",
    transform: "translate(0,0)"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98938C",
    transform: "translate(0,0)"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999386",
    transform: "translate(0,0)"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999184",
    transform: "translate(0,0)"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926C",
    transform: "translate(0,0)"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB945A",
    transform: "translate(0,0)"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9559",
    transform: "translate(0,0)"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9A12F",
    transform: "translate(0,0)"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928D",
    transform: "translate(0,0)"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0907A",
    transform: "translate(0,0)"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999285",
    transform: "translate(0,0)"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958F",
    transform: "translate(0,0)"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979187",
    transform: "translate(0,0)"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9284",
    transform: "translate(0,0)"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1917C",
    transform: "translate(0,0)"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA926C",
    transform: "translate(0,0)"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D29942",
    transform: "translate(0,0)"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29277",
    transform: "translate(0,0)"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958F",
    transform: "translate(0,0)"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907B",
    transform: "translate(0,0)"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95958E",
    transform: "translate(0,0)"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999386",
    transform: "translate(0,0)"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB936C",
    transform: "translate(0,0)"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9286",
    transform: "translate(0,0)"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9182",
    transform: "translate(0,0)"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE9844",
    transform: "translate(0,0)"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B79564",
    transform: "translate(0,0)"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF946A",
    transform: "translate(0,0)"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9C",
    transform: "translate(0,0)"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9081",
    transform: "translate(0,0)"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938E",
    transform: "translate(0,0)"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999386",
    transform: "translate(0,0)"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999185",
    transform: "translate(0,0)"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29275",
    transform: "translate(0,0)"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB926D",
    transform: "translate(0,0)"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907B",
    transform: "translate(0,0)"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EF9D22",
    transform: "translate(0,0)"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979286",
    transform: "translate(0,0)"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989386",
    transform: "translate(0,0)"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9383",
    transform: "translate(0,0)"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9180",
    transform: "translate(0,0)"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0917B",
    transform: "translate(0,0)"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9916E",
    transform: "translate(0,0)"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39364",
    transform: "translate(0,0)"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97958E",
    transform: "translate(0,0)"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9A",
    transform: "translate(0,0)"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA2",
    transform: "translate(0,0)"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969492",
    transform: "translate(0,0)"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96948C",
    transform: "translate(0,0)"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9187",
    transform: "translate(0,0)"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9183",
    transform: "translate(0,0)"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C99648",
    transform: "translate(0,0)"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49466",
    transform: "translate(0,0)"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AE926B",
    transform: "translate(0,0)"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928E",
    transform: "translate(0,0)"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989388",
    transform: "translate(0,0)"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19277",
    transform: "translate(0,0)"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA926F",
    transform: "translate(0,0)"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6935F",
    transform: "translate(0,0)"
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F907B",
    transform: "translate(0,0)"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979187",
    transform: "translate(0,0)"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989287",
    transform: "translate(0,0)"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8916F",
    transform: "translate(0,0)"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C8974B",
    transform: "translate(0,0)"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F927B",
    transform: "translate(0,0)"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B69260",
    transform: "translate(0,0)"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09365",
    transform: "translate(0,0)"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA19F",
    transform: "translate(0,0)"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96968F",
    transform: "translate(0,0)"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938F",
    transform: "translate(0,0)"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B39461",
    transform: "translate(0,0)"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C6974D",
    transform: "translate(0,0)"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969691",
    transform: "translate(0,0)"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97938F",
    transform: "translate(0,0)"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9284",
    transform: "translate(0,0)"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6906F",
    transform: "translate(0,0)"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BB9457",
    transform: "translate(0,0)"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3964E",
    transform: "translate(0,0)"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19469",
    transform: "translate(0,0)"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969691",
    transform: "translate(0,0)"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938F",
    transform: "translate(0,0)"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979388",
    transform: "translate(0,0)"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9083",
    transform: "translate(0,0)"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F7E",
    transform: "translate(0,0)"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19263",
    transform: "translate(0,0)"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989794",
    transform: "translate(0,0)"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979490",
    transform: "translate(0,0)"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969387",
    transform: "translate(0,0)"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49173",
    transform: "translate(0,0)"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C29451",
    transform: "translate(0,0)"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8955F",
    transform: "translate(0,0)"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969388",
    transform: "translate(0,0)"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09FA1",
    transform: "translate(0,0)"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D9D",
    transform: "translate(0,0)"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98989A",
    transform: "translate(0,0)"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989797",
    transform: "translate(0,0)"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9286",
    transform: "translate(0,0)"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49073",
    transform: "translate(0,0)"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59173",
    transform: "translate(0,0)"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD9453",
    transform: "translate(0,0)"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF936B",
    transform: "translate(0,0)"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9926E",
    transform: "translate(0,0)"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959390",
    transform: "translate(0,0)"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59173",
    transform: "translate(0,0)"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9080",
    transform: "translate(0,0)"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959289",
    transform: "translate(0,0)"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9180",
    transform: "translate(0,0)"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9181",
    transform: "translate(0,0)"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39073",
    transform: "translate(0,0)"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B49462",
    transform: "translate(0,0)"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19E",
    transform: "translate(0,0)"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94948F",
    transform: "translate(0,0)"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989284",
    transform: "translate(0,0)"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A39174",
    transform: "translate(0,0)"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9916C",
    transform: "translate(0,0)"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF9267",
    transform: "translate(0,0)"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BD9357",
    transform: "translate(0,0)"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9C",
    transform: "translate(0,0)"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959692",
    transform: "translate(0,0)"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959490",
    transform: "translate(0,0)"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97918B",
    transform: "translate(0,0)"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9183",
    transform: "translate(0,0)"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49175",
    transform: "translate(0,0)"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9257",
    transform: "translate(0,0)"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC926D",
    transform: "translate(0,0)"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A79372",
    transform: "translate(0,0)"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9D",
    transform: "translate(0,0)"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19076",
    transform: "translate(0,0)"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B19160",
    transform: "translate(0,0)"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938F",
    transform: "translate(0,0)"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97928A",
    transform: "translate(0,0)"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9080",
    transform: "translate(0,0)"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA9268",
    transform: "translate(0,0)"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9167",
    transform: "translate(0,0)"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9C",
    transform: "translate(0,0)"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9B",
    transform: "translate(0,0)"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969288",
    transform: "translate(0,0)"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969188",
    transform: "translate(0,0)"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999180",
    transform: "translate(0,0)"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917D",
    transform: "translate(0,0)"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8F7A",
    transform: "translate(0,0)"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28F76",
    transform: "translate(0,0)"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8915A",
    transform: "translate(0,0)"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9069",
    transform: "translate(0,0)"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6916E",
    transform: "translate(0,0)"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949390",
    transform: "translate(0,0)"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928B",
    transform: "translate(0,0)"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19276",
    transform: "translate(0,0)"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB9269",
    transform: "translate(0,0)"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BA9356",
    transform: "translate(0,0)"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA29F",
    transform: "translate(0,0)"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA1",
    transform: "translate(0,0)"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB916D",
    transform: "translate(0,0)"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD916A",
    transform: "translate(0,0)"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4915C",
    transform: "translate(0,0)"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C99546",
    transform: "translate(0,0)"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89170",
    transform: "translate(0,0)"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999183",
    transform: "translate(0,0)"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19077",
    transform: "translate(0,0)"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69171",
    transform: "translate(0,0)"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96938A",
    transform: "translate(0,0)"
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999181",
    transform: "translate(0,0)"
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19077",
    transform: "translate(0,0)"
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8916B",
    transform: "translate(0,0)"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09D",
    transform: "translate(0,0)"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928A",
    transform: "translate(0,0)"
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979289",
    transform: "translate(0,0)"
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989082",
    transform: "translate(0,0)"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9076",
    transform: "translate(0,0)"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09262",
    transform: "translate(0,0)"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4915D",
    transform: "translate(0,0)"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9167",
    transform: "translate(0,0)"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938A",
    transform: "translate(0,0)"
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979285",
    transform: "translate(0,0)"
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09177",
    transform: "translate(0,0)"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59071",
    transform: "translate(0,0)"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69271",
    transform: "translate(0,0)"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999288",
    transform: "translate(0,0)"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9185",
    transform: "translate(0,0)"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8F79",
    transform: "translate(0,0)"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A89070",
    transform: "translate(0,0)"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09060",
    transform: "translate(0,0)"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C2944E",
    transform: "translate(0,0)"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C3934D",
    transform: "translate(0,0)"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A69272",
    transform: "translate(0,0)"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29176",
    transform: "translate(0,0)"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A1",
    transform: "translate(0,0)"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49174",
    transform: "translate(0,0)"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989284",
    transform: "translate(0,0)"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C4934F",
    transform: "translate(0,0)"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938C",
    transform: "translate(0,0)"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918A",
    transform: "translate(0,0)"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9079",
    transform: "translate(0,0)"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09162",
    transform: "translate(0,0)"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA906B",
    transform: "translate(0,0)"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19074",
    transform: "translate(0,0)"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C907C",
    transform: "translate(0,0)"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9284",
    transform: "translate(0,0)"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959591",
    transform: "translate(0,0)"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9283",
    transform: "translate(0,0)"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6916F",
    transform: "translate(0,0)"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A0",
    transform: "translate(0,0)"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9F",
    transform: "translate(0,0)"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979798",
    transform: "translate(0,0)"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949693",
    transform: "translate(0,0)"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979189",
    transform: "translate(0,0)"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999186",
    transform: "translate(0,0)"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8F64",
    transform: "translate(0,0)"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BC9454",
    transform: "translate(0,0)"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38F71",
    transform: "translate(0,0)"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949491",
    transform: "translate(0,0)"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95938C",
    transform: "translate(0,0)"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48F6F",
    transform: "translate(0,0)"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8916D",
    transform: "translate(0,0)"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9064",
    transform: "translate(0,0)"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9C",
    transform: "translate(0,0)"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928C",
    transform: "translate(0,0)"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928D",
    transform: "translate(0,0)"
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F7C",
    transform: "translate(0,0)"
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A49172",
    transform: "translate(0,0)"
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9067",
    transform: "translate(0,0)"
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5906E",
    transform: "translate(0,0)"
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6906E",
    transform: "translate(0,0)"
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F74",
    transform: "translate(0,0)"
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949592",
    transform: "translate(0,0)"
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969185",
    transform: "translate(0,0)"
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D907C",
    transform: "translate(0,0)"
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC9267",
    transform: "translate(0,0)"
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928A",
    transform: "translate(0,0)"
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D907D",
    transform: "translate(0,0)"
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A99066",
    transform: "translate(0,0)"
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19176",
    transform: "translate(0,0)"
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9079",
    transform: "translate(0,0)"
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959085",
    transform: "translate(0,0)"
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989288",
    transform: "translate(0,0)"
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969085",
    transform: "translate(0,0)"
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48F6E",
    transform: "translate(0,0)"
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29071",
    transform: "translate(0,0)"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09076",
    transform: "translate(0,0)"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A19F",
    transform: "translate(0,0)"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938C",
    transform: "translate(0,0)"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B907E",
    transform: "translate(0,0)"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A99069",
    transform: "translate(0,0)"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9077",
    transform: "translate(0,0)"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9C",
    transform: "translate(0,0)"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938E",
    transform: "translate(0,0)"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A917D",
    transform: "translate(0,0)"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2915F",
    transform: "translate(0,0)"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E917A",
    transform: "translate(0,0)"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918E",
    transform: "translate(0,0)"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97918B",
    transform: "translate(0,0)"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7D",
    transform: "translate(0,0)"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A59070",
    transform: "translate(0,0)"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A78E6B",
    transform: "translate(0,0)"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2905D",
    transform: "translate(0,0)"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F78",
    transform: "translate(0,0)"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8F78",
    transform: "translate(0,0)"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938E",
    transform: "translate(0,0)"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969595",
    transform: "translate(0,0)"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989087",
    transform: "translate(0,0)"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969086",
    transform: "translate(0,0)"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94958E",
    transform: "translate(0,0)"
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979187",
    transform: "translate(0,0)"
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969184",
    transform: "translate(0,0)"
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7F",
    transform: "translate(0,0)"
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8F76",
    transform: "translate(0,0)"
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F76",
    transform: "translate(0,0)"
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9078",
    transform: "translate(0,0)"
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928D",
    transform: "translate(0,0)"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918D",
    transform: "translate(0,0)"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998F80",
    transform: "translate(0,0)"
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9076",
    transform: "translate(0,0)"
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68F6D",
    transform: "translate(0,0)"
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A98F69",
    transform: "translate(0,0)"
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08F72",
    transform: "translate(0,0)"
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8E79",
    transform: "translate(0,0)"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28E72",
    transform: "translate(0,0)"
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9078",
    transform: "translate(0,0)"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58F6E",
    transform: "translate(0,0)"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58E6A",
    transform: "translate(0,0)"
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9079",
    transform: "translate(0,0)"
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928F",
    transform: "translate(0,0)"
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96928B",
    transform: "translate(0,0)"
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38F6E",
    transform: "translate(0,0)"
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF8F61",
    transform: "translate(0,0)"
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B09060",
    transform: "translate(0,0)"
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A88F66",
    transform: "translate(0,0)"
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8F7A",
    transform: "translate(0,0)"
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F7B",
    transform: "translate(0,0)"
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949794",
    transform: "translate(0,0)"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93938D",
    transform: "translate(0,0)"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8E77",
    transform: "translate(0,0)"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18F75",
    transform: "translate(0,0)"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8E63",
    transform: "translate(0,0)"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F79",
    transform: "translate(0,0)"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979081",
    transform: "translate(0,0)"
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979996",
    transform: "translate(0,0)"
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68F6E",
    transform: "translate(0,0)"
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA29F",
    transform: "translate(0,0)"
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918E",
    transform: "translate(0,0)"
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979081",
    transform: "translate(0,0)"
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28D6F",
    transform: "translate(0,0)"
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8F65",
    transform: "translate(0,0)"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8E74",
    transform: "translate(0,0)"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8F7B",
    transform: "translate(0,0)"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F81",
    transform: "translate(0,0)"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9D",
    transform: "translate(0,0)"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A88D65",
    transform: "translate(0,0)"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A907F",
    transform: "translate(0,0)"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F7A",
    transform: "translate(0,0)"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19075",
    transform: "translate(0,0)"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9C",
    transform: "translate(0,0)"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939390",
    transform: "translate(0,0)"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959390",
    transform: "translate(0,0)"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928C",
    transform: "translate(0,0)"
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95908B",
    transform: "translate(0,0)"
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E8E77",
    transform: "translate(0,0)"
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48D6C",
    transform: "translate(0,0)"
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AA8F65",
    transform: "translate(0,0)"
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB8E63",
    transform: "translate(0,0)"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48D6A",
    transform: "translate(0,0)"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18D6F",
    transform: "translate(0,0)"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F7B",
    transform: "translate(0,0)"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F7B",
    transform: "translate(0,0)"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98907D",
    transform: "translate(0,0)"
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F83",
    transform: "translate(0,0)"
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939290",
    transform: "translate(0,0)"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A2",
    transform: "translate(0,0)"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9C",
    transform: "translate(0,0)"
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F82",
    transform: "translate(0,0)"
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8E79",
    transform: "translate(0,0)"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A88F66",
    transform: "translate(0,0)"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08D6F",
    transform: "translate(0,0)"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7A",
    transform: "translate(0,0)"
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938E",
    transform: "translate(0,0)"
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928A",
    transform: "translate(0,0)"
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969186",
    transform: "translate(0,0)"
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968F83",
    transform: "translate(0,0)"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08E72",
    transform: "translate(0,0)"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28D6D",
    transform: "translate(0,0)"
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8C6E",
    transform: "translate(0,0)"
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C71",
    transform: "translate(0,0)"
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8D78",
    transform: "translate(0,0)"
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8E7A",
    transform: "translate(0,0)"
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988E7D",
    transform: "translate(0,0)"
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939695",
    transform: "translate(0,0)"
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA09F",
    transform: "translate(0,0)"
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F7B",
    transform: "translate(0,0)"
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C70",
    transform: "translate(0,0)"
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A58E6A",
    transform: "translate(0,0)"
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988E7C",
    transform: "translate(0,0)"
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998F80",
    transform: "translate(0,0)"
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9D",
    transform: "translate(0,0)"
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95928C",
    transform: "translate(0,0)"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95918B",
    transform: "translate(0,0)"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F82",
    transform: "translate(0,0)"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A18C6E",
    transform: "translate(0,0)"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7E",
    transform: "translate(0,0)"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9C",
    transform: "translate(0,0)"
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949492",
    transform: "translate(0,0)"
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95908A",
    transform: "translate(0,0)"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979083",
    transform: "translate(0,0)"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F7C",
    transform: "translate(0,0)"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68C6A",
    transform: "translate(0,0)"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A68D68",
    transform: "translate(0,0)"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949189",
    transform: "translate(0,0)"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F84",
    transform: "translate(0,0)"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99907C",
    transform: "translate(0,0)"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8F77",
    transform: "translate(0,0)"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8D74",
    transform: "translate(0,0)"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38E6B",
    transform: "translate(0,0)"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E7F",
    transform: "translate(0,0)"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA2A0",
    transform: "translate(0,0)"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939394",
    transform: "translate(0,0)"
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F7A",
    transform: "translate(0,0)"
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8F75",
    transform: "translate(0,0)"
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A38C6B",
    transform: "translate(0,0)"
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969081",
    transform: "translate(0,0)"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9C",
    transform: "translate(0,0)"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D84",
    transform: "translate(0,0)"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959085",
    transform: "translate(0,0)"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F7D",
    transform: "translate(0,0)"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998E7C",
    transform: "translate(0,0)"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8C75",
    transform: "translate(0,0)"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8B73",
    transform: "translate(0,0)"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08B6E",
    transform: "translate(0,0)"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A28C6B",
    transform: "translate(0,0)"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7F",
    transform: "translate(0,0)"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968D80",
    transform: "translate(0,0)"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A0A2",
    transform: "translate(0,0)"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998C79",
    transform: "translate(0,0)"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949492",
    transform: "translate(0,0)"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918C",
    transform: "translate(0,0)"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949188",
    transform: "translate(0,0)"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959185",
    transform: "translate(0,0)"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D7C",
    transform: "translate(0,0)"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8D75",
    transform: "translate(0,0)"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968D7E",
    transform: "translate(0,0)"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94908B",
    transform: "translate(0,0)"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918B",
    transform: "translate(0,0)"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939390",
    transform: "translate(0,0)"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949086",
    transform: "translate(0,0)"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F7F",
    transform: "translate(0,0)"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8D77",
    transform: "translate(0,0)"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988A77",
    transform: "translate(0,0)"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978C7B",
    transform: "translate(0,0)"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F81",
    transform: "translate(0,0)"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09E",
    transform: "translate(0,0)"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA19F",
    transform: "translate(0,0)"
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929595",
    transform: "translate(0,0)"
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949185",
    transform: "translate(0,0)"
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C6E",
    transform: "translate(0,0)"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968E83",
    transform: "translate(0,0)"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939086",
    transform: "translate(0,0)"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979798",
    transform: "translate(0,0)"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918D",
    transform: "translate(0,0)"
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E85",
    transform: "translate(0,0)"
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D78",
    transform: "translate(0,0)"
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8C75",
    transform: "translate(0,0)"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A08C6E",
    transform: "translate(0,0)"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C8C73",
    transform: "translate(0,0)"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F82",
    transform: "translate(0,0)"
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D81",
    transform: "translate(0,0)"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949591",
    transform: "translate(0,0)"
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948F86",
    transform: "translate(0,0)"
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7F",
    transform: "translate(0,0)"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94908B",
    transform: "translate(0,0)"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959795",
    transform: "translate(0,0)"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949086",
    transform: "translate(0,0)"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978F82",
    transform: "translate(0,0)"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D7A",
    transform: "translate(0,0)"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8B73",
    transform: "translate(0,0)"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B8C77",
    transform: "translate(0,0)"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958C7C",
    transform: "translate(0,0)"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D83",
    transform: "translate(0,0)"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939186",
    transform: "translate(0,0)"
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#998D7A",
    transform: "translate(0,0)"
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949490",
    transform: "translate(0,0)"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9E",
    transform: "translate(0,0)"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959596",
    transform: "translate(0,0)"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939086",
    transform: "translate(0,0)"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968E81",
    transform: "translate(0,0)"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978C79",
    transform: "translate(0,0)"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8C73",
    transform: "translate(0,0)"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8B71",
    transform: "translate(0,0)"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D82",
    transform: "translate(0,0)"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D83",
    transform: "translate(0,0)"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D8B72",
    transform: "translate(0,0)"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959495",
    transform: "translate(0,0)"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929591",
    transform: "translate(0,0)"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918A",
    transform: "translate(0,0)"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949088",
    transform: "translate(0,0)"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929490",
    transform: "translate(0,0)"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93908E",
    transform: "translate(0,0)"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918E",
    transform: "translate(0,0)"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F8A",
    transform: "translate(0,0)"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F88",
    transform: "translate(0,0)"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968E83",
    transform: "translate(0,0)"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978C7A",
    transform: "translate(0,0)"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988C79",
    transform: "translate(0,0)"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948C7C",
    transform: "translate(0,0)"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948C7E",
    transform: "translate(0,0)"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D83",
    transform: "translate(0,0)"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D81",
    transform: "translate(0,0)"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E9E",
    transform: "translate(0,0)"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA1A0",
    transform: "translate(0,0)"
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918D",
    transform: "translate(0,0)"
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94928B",
    transform: "translate(0,0)"
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939088",
    transform: "translate(0,0)"
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968B7B",
    transform: "translate(0,0)"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9D",
    transform: "translate(0,0)"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A19F",
    transform: "translate(0,0)"
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94938F",
    transform: "translate(0,0)"
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F87",
    transform: "translate(0,0)"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949089",
    transform: "translate(0,0)"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#988F7F",
    transform: "translate(0,0)"
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D7B",
    transform: "translate(0,0)"
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A8C74",
    transform: "translate(0,0)"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D84",
    transform: "translate(0,0)"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D85",
    transform: "translate(0,0)"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A2",
    transform: "translate(0,0)"
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908E",
    transform: "translate(0,0)"
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09F",
    transform: "translate(0,0)"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#94918E",
    transform: "translate(0,0)"
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918B",
    transform: "translate(0,0)"
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929089",
    transform: "translate(0,0)"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958E82",
    transform: "translate(0,0)"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918D",
    transform: "translate(0,0)"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978E7C",
    transform: "translate(0,0)"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A0",
    transform: "translate(0,0)"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919592",
    transform: "translate(0,0)"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949392",
    transform: "translate(0,0)"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F89",
    transform: "translate(0,0)"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939084",
    transform: "translate(0,0)"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968C7D",
    transform: "translate(0,0)"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928C7E",
    transform: "translate(0,0)"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918C80",
    transform: "translate(0,0)"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D81",
    transform: "translate(0,0)"
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C84",
    transform: "translate(0,0)"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA2A0",
    transform: "translate(0,0)"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949697",
    transform: "translate(0,0)"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949089",
    transform: "translate(0,0)"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F84",
    transform: "translate(0,0)"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978A75",
    transform: "translate(0,0)"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F85",
    transform: "translate(0,0)"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A4",
    transform: "translate(0,0)"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A3",
    transform: "translate(0,0)"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959799",
    transform: "translate(0,0)"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959491",
    transform: "translate(0,0)"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E89",
    transform: "translate(0,0)"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968B7C",
    transform: "translate(0,0)"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968A76",
    transform: "translate(0,0)"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E85",
    transform: "translate(0,0)"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F86",
    transform: "translate(0,0)"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908D",
    transform: "translate(0,0)"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D81",
    transform: "translate(0,0)"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E85",
    transform: "translate(0,0)"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9C9E",
    transform: "translate(0,0)"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939692",
    transform: "translate(0,0)"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949291",
    transform: "translate(0,0)"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F85",
    transform: "translate(0,0)"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948D82",
    transform: "translate(0,0)"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968C7A",
    transform: "translate(0,0)"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E85",
    transform: "translate(0,0)"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928E",
    transform: "translate(0,0)"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948E84",
    transform: "translate(0,0)"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928C",
    transform: "translate(0,0)"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93908A",
    transform: "translate(0,0)"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908A",
    transform: "translate(0,0)"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F86",
    transform: "translate(0,0)"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958C7F",
    transform: "translate(0,0)"
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D86",
    transform: "translate(0,0)"
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F84",
    transform: "translate(0,0)"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8C85",
    transform: "translate(0,0)"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA1",
    transform: "translate(0,0)"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928A",
    transform: "translate(0,0)"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918A",
    transform: "translate(0,0)"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F84",
    transform: "translate(0,0)"
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958D82",
    transform: "translate(0,0)"
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968D7D",
    transform: "translate(0,0)"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#978A78",
    transform: "translate(0,0)"
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9E",
    transform: "translate(0,0)"
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9F",
    transform: "translate(0,0)"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949290",
    transform: "translate(0,0)"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93928F",
    transform: "translate(0,0)"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#958F88",
    transform: "translate(0,0)"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938B7B",
    transform: "translate(0,0)"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#968B79",
    transform: "translate(0,0)"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928B7D",
    transform: "translate(0,0)"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F87",
    transform: "translate(0,0)"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9F",
    transform: "translate(0,0)"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929290",
    transform: "translate(0,0)"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91938D",
    transform: "translate(0,0)"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918B",
    transform: "translate(0,0)"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F86",
    transform: "translate(0,0)"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939290",
    transform: "translate(0,0)"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F87",
    transform: "translate(0,0)"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939592",
    transform: "translate(0,0)"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949494",
    transform: "translate(0,0)"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918B",
    transform: "translate(0,0)"
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938C81",
    transform: "translate(0,0)"
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D82",
    transform: "translate(0,0)"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D84",
    transform: "translate(0,0)"
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E86",
    transform: "translate(0,0)"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E88",
    transform: "translate(0,0)"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928F",
    transform: "translate(0,0)"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938C7B",
    transform: "translate(0,0)"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A0",
    transform: "translate(0,0)"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948B7C",
    transform: "translate(0,0)"
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928A7D",
    transform: "translate(0,0)"
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A3",
    transform: "translate(0,0)"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A999C",
    transform: "translate(0,0)"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949494",
    transform: "translate(0,0)"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959592",
    transform: "translate(0,0)"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908B",
    transform: "translate(0,0)"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918C",
    transform: "translate(0,0)"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938F87",
    transform: "translate(0,0)"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E85",
    transform: "translate(0,0)"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#948B7A",
    transform: "translate(0,0)"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E88",
    transform: "translate(0,0)"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F88",
    transform: "translate(0,0)"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939491",
    transform: "translate(0,0)"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA19F",
    transform: "translate(0,0)"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949794",
    transform: "translate(0,0)"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F88",
    transform: "translate(0,0)"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928C81",
    transform: "translate(0,0)"
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D7B",
    transform: "translate(0,0)"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928A7E",
    transform: "translate(0,0)"
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939390",
    transform: "translate(0,0)"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918C81",
    transform: "translate(0,0)"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA3A1",
    transform: "translate(0,0)"
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939693",
    transform: "translate(0,0)"
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959493",
    transform: "translate(0,0)"
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918C",
    transform: "translate(0,0)"
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8A",
    transform: "translate(0,0)"
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929089",
    transform: "translate(0,0)"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928C83",
    transform: "translate(0,0)"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938C81",
    transform: "translate(0,0)"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938C7C",
    transform: "translate(0,0)"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928A7E",
    transform: "translate(0,0)"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D85",
    transform: "translate(0,0)"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D87",
    transform: "translate(0,0)"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919086",
    transform: "translate(0,0)"
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C82",
    transform: "translate(0,0)"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918B80",
    transform: "translate(0,0)"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A0",
    transform: "translate(0,0)"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9A",
    transform: "translate(0,0)"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949491",
    transform: "translate(0,0)"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938B7D",
    transform: "translate(0,0)"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8A",
    transform: "translate(0,0)"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D8A",
    transform: "translate(0,0)"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E86",
    transform: "translate(0,0)"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E88",
    transform: "translate(0,0)"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93918E",
    transform: "translate(0,0)"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908A",
    transform: "translate(0,0)"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928E88",
    transform: "translate(0,0)"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928C7D",
    transform: "translate(0,0)"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A5",
    transform: "translate(0,0)"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949693",
    transform: "translate(0,0)"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918E",
    transform: "translate(0,0)"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928D85",
    transform: "translate(0,0)"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C84",
    transform: "translate(0,0)"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918D87",
    transform: "translate(0,0)"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908B",
    transform: "translate(0,0)"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F8A",
    transform: "translate(0,0)"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959899",
    transform: "translate(0,0)"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938E",
    transform: "translate(0,0)"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918C",
    transform: "translate(0,0)"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919086",
    transform: "translate(0,0)"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959494",
    transform: "translate(0,0)"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908E",
    transform: "translate(0,0)"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908B",
    transform: "translate(0,0)"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D86",
    transform: "translate(0,0)"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918B7F",
    transform: "translate(0,0)"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908A7F",
    transform: "translate(0,0)"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E8A",
    transform: "translate(0,0)"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929394",
    transform: "translate(0,0)"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918F",
    transform: "translate(0,0)"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#928F89",
    transform: "translate(0,0)"
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D86",
    transform: "translate(0,0)"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#938D80",
    transform: "translate(0,0)"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908A",
    transform: "translate(0,0)"
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A1",
    transform: "translate(0,0)"
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A1",
    transform: "translate(0,0)"
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949390",
    transform: "translate(0,0)"
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8D",
    transform: "translate(0,0)"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D87",
    transform: "translate(0,0)"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D85",
    transform: "translate(0,0)"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908C81",
    transform: "translate(0,0)"
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918A7F",
    transform: "translate(0,0)"
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C85",
    transform: "translate(0,0)"
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9B",
    transform: "translate(0,0)"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A4",
    transform: "translate(0,0)"
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92938F",
    transform: "translate(0,0)"
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908D",
    transform: "translate(0,0)"
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999B",
    transform: "translate(0,0)"
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969694",
    transform: "translate(0,0)"
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928F",
    transform: "translate(0,0)"
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939290",
    transform: "translate(0,0)"
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908D",
    transform: "translate(0,0)"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918B",
    transform: "translate(0,0)"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E87",
    transform: "translate(0,0)"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8B83",
    transform: "translate(0,0)"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E8D",
    transform: "translate(0,0)"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8B",
    transform: "translate(0,0)"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989798",
    transform: "translate(0,0)"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96989A",
    transform: "translate(0,0)"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959895",
    transform: "translate(0,0)"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908C",
    transform: "translate(0,0)"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E83",
    transform: "translate(0,0)"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949493",
    transform: "translate(0,0)"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E88",
    transform: "translate(0,0)"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919390",
    transform: "translate(0,0)"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918E",
    transform: "translate(0,0)"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F89",
    transform: "translate(0,0)"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908B82",
    transform: "translate(0,0)"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C87",
    transform: "translate(0,0)"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D89",
    transform: "translate(0,0)"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8D",
    transform: "translate(0,0)"
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969995",
    transform: "translate(0,0)"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919490",
    transform: "translate(0,0)"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959494",
    transform: "translate(0,0)"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908E",
    transform: "translate(0,0)"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908D",
    transform: "translate(0,0)"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979799",
    transform: "translate(0,0)"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918D",
    transform: "translate(0,0)"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E86",
    transform: "translate(0,0)"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908C",
    transform: "translate(0,0)"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918C",
    transform: "translate(0,0)"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A2",
    transform: "translate(0,0)"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A4",
    transform: "translate(0,0)"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959895",
    transform: "translate(0,0)"
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8A",
    transform: "translate(0,0)"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F89",
    transform: "translate(0,0)"
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8B83",
    transform: "translate(0,0)"
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8B87",
    transform: "translate(0,0)"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8A",
    transform: "translate(0,0)"
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8A",
    transform: "translate(0,0)"
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8F8D",
    transform: "translate(0,0)"
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8F8C",
    transform: "translate(0,0)"
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E9F",
    transform: "translate(0,0)"
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928D",
    transform: "translate(0,0)"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908B",
    transform: "translate(0,0)"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E89",
    transform: "translate(0,0)"
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D86",
    transform: "translate(0,0)"
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979798",
    transform: "translate(0,0)"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959593",
    transform: "translate(0,0)"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928E",
    transform: "translate(0,0)"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8B",
    transform: "translate(0,0)"
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8B87",
    transform: "translate(0,0)"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8C85",
    transform: "translate(0,0)"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8C87",
    transform: "translate(0,0)"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918F",
    transform: "translate(0,0)"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999A",
    transform: "translate(0,0)"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979996",
    transform: "translate(0,0)"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949494",
    transform: "translate(0,0)"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918D",
    transform: "translate(0,0)"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918C",
    transform: "translate(0,0)"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908B",
    transform: "translate(0,0)"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908B",
    transform: "translate(0,0)"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929592",
    transform: "translate(0,0)"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E8B",
    transform: "translate(0,0)"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A0",
    transform: "translate(0,0)"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8B",
    transform: "translate(0,0)"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D86",
    transform: "translate(0,0)"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919190",
    transform: "translate(0,0)"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918E",
    transform: "translate(0,0)"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A0",
    transform: "translate(0,0)"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B98",
    transform: "translate(0,0)"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918F",
    transform: "translate(0,0)"
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E88",
    transform: "translate(0,0)"
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A1",
    transform: "translate(0,0)"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A1",
    transform: "translate(0,0)"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959997",
    transform: "translate(0,0)"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989798",
    transform: "translate(0,0)"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919393",
    transform: "translate(0,0)"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908C",
    transform: "translate(0,0)"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918F8B",
    transform: "translate(0,0)"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8B",
    transform: "translate(0,0)"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8B",
    transform: "translate(0,0)"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8D",
    transform: "translate(0,0)"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9290",
    transform: "translate(0,0)"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9B",
    transform: "translate(0,0)"
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8A87",
    transform: "translate(0,0)"
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A2",
    transform: "translate(0,0)"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9F",
    transform: "translate(0,0)"
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9D",
    transform: "translate(0,0)"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919191",
    transform: "translate(0,0)"
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908F8D",
    transform: "translate(0,0)"
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8B",
    transform: "translate(0,0)"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D89",
    transform: "translate(0,0)"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8C89",
    transform: "translate(0,0)"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8C8B",
    transform: "translate(0,0)"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8C8A",
    transform: "translate(0,0)"
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E8A",
    transform: "translate(0,0)"
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919192",
    transform: "translate(0,0)"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919190",
    transform: "translate(0,0)"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8C8B",
    transform: "translate(0,0)"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999B",
    transform: "translate(0,0)"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A98",
    transform: "translate(0,0)"
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959596",
    transform: "translate(0,0)"
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929391",
    transform: "translate(0,0)"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919190",
    transform: "translate(0,0)"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909190",
    transform: "translate(0,0)"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9089",
    transform: "translate(0,0)"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E88",
    transform: "translate(0,0)"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909390",
    transform: "translate(0,0)"
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918D",
    transform: "translate(0,0)"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A2",
    transform: "translate(0,0)"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959896",
    transform: "translate(0,0)"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9391",
    transform: "translate(0,0)"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8B",
    transform: "translate(0,0)"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D87",
    transform: "translate(0,0)"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D8B",
    transform: "translate(0,0)"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908D",
    transform: "translate(0,0)"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918F",
    transform: "translate(0,0)"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9191",
    transform: "translate(0,0)"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909391",
    transform: "translate(0,0)"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A1",
    transform: "translate(0,0)"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9F",
    transform: "translate(0,0)"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9C",
    transform: "translate(0,0)"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919490",
    transform: "translate(0,0)"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8A",
    transform: "translate(0,0)"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A0",
    transform: "translate(0,0)"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA2",
    transform: "translate(0,0)"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939393",
    transform: "translate(0,0)"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8D89",
    transform: "translate(0,0)"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E89",
    transform: "translate(0,0)"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8D8A",
    transform: "translate(0,0)"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8E",
    transform: "translate(0,0)"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919391",
    transform: "translate(0,0)"
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A1",
    transform: "translate(0,0)"
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A4",
    transform: "translate(0,0)"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F928F",
    transform: "translate(0,0)"
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8C8B",
    transform: "translate(0,0)"
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8C89",
    transform: "translate(0,0)"
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919391",
    transform: "translate(0,0)"
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908F",
    transform: "translate(0,0)"
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8C",
    transform: "translate(0,0)"
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F89",
    transform: "translate(0,0)"
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8B",
    transform: "translate(0,0)"
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A3",
    transform: "translate(0,0)"
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949897",
    transform: "translate(0,0)"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92908E",
    transform: "translate(0,0)"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E89",
    transform: "translate(0,0)"
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908E8C",
    transform: "translate(0,0)"
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E918F",
    transform: "translate(0,0)"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919191",
    transform: "translate(0,0)"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919390",
    transform: "translate(0,0)"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9393",
    transform: "translate(0,0)"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929494",
    transform: "translate(0,0)"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909390",
    transform: "translate(0,0)"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9190",
    transform: "translate(0,0)"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9C",
    transform: "translate(0,0)"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939394",
    transform: "translate(0,0)"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9190",
    transform: "translate(0,0)"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8A",
    transform: "translate(0,0)"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919393",
    transform: "translate(0,0)"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A4",
    transform: "translate(0,0)"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928F",
    transform: "translate(0,0)"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A2",
    transform: "translate(0,0)"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949795",
    transform: "translate(0,0)"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929592",
    transform: "translate(0,0)"
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929392",
    transform: "translate(0,0)"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91918F",
    transform: "translate(0,0)"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919491",
    transform: "translate(0,0)"
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919494",
    transform: "translate(0,0)"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909290",
    transform: "translate(0,0)"
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928E",
    transform: "translate(0,0)"
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8E8B",
    transform: "translate(0,0)"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9190",
    transform: "translate(0,0)"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909091",
    transform: "translate(0,0)"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919493",
    transform: "translate(0,0)"
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919493",
    transform: "translate(0,0)"
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA3A2",
    transform: "translate(0,0)"
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A5",
    transform: "translate(0,0)"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A1",
    transform: "translate(0,0)"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A1",
    transform: "translate(0,0)"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9D",
    transform: "translate(0,0)"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918F",
    transform: "translate(0,0)"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908F",
    transform: "translate(0,0)"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A1",
    transform: "translate(0,0)"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A2",
    transform: "translate(0,0)"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90918F",
    transform: "translate(0,0)"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E8F",
    transform: "translate(0,0)"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8B",
    transform: "translate(0,0)"
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8C",
    transform: "translate(0,0)"
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918F",
    transform: "translate(0,0)"
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9191",
    transform: "translate(0,0)"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929393",
    transform: "translate(0,0)"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A4",
    transform: "translate(0,0)"
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E8C",
    transform: "translate(0,0)"
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919393",
    transform: "translate(0,0)"
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9290",
    transform: "translate(0,0)"
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928E",
    transform: "translate(0,0)"
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908D",
    transform: "translate(0,0)"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919491",
    transform: "translate(0,0)"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A3",
    transform: "translate(0,0)"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A2",
    transform: "translate(0,0)"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9C",
    transform: "translate(0,0)"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919391",
    transform: "translate(0,0)"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A4",
    transform: "translate(0,0)"
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999999",
    transform: "translate(0,0)"
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9D",
    transform: "translate(0,0)"
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9090",
    transform: "translate(0,0)"
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A2",
    transform: "translate(0,0)"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A3",
    transform: "translate(0,0)"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909190",
    transform: "translate(0,0)"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908E",
    transform: "translate(0,0)"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E908D",
    transform: "translate(0,0)"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA0",
    transform: "translate(0,0)"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909290",
    transform: "translate(0,0)"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A5",
    transform: "translate(0,0)"
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9D",
    transform: "translate(0,0)"
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A97",
    transform: "translate(0,0)"
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929494",
    transform: "translate(0,0)"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F938F",
    transform: "translate(0,0)"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989898",
    transform: "translate(0,0)"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A3",
    transform: "translate(0,0)"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A999C",
    transform: "translate(0,0)"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999B",
    transform: "translate(0,0)"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929392",
    transform: "translate(0,0)"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929595",
    transform: "translate(0,0)"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929694",
    transform: "translate(0,0)"
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A3",
    transform: "translate(0,0)"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A3",
    transform: "translate(0,0)"
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9F9E",
    transform: "translate(0,0)"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A2",
    transform: "translate(0,0)"
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A5",
    transform: "translate(0,0)"
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A6",
    transform: "translate(0,0)"
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9EA0",
    transform: "translate(0,0)"
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9D9D",
    transform: "translate(0,0)"
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9A9B",
    transform: "translate(0,0)"
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939897",
    transform: "translate(0,0)"
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909392",
    transform: "translate(0,0)"
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928E",
    transform: "translate(0,0)"
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F8F",
    transform: "translate(0,0)"
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919190",
    transform: "translate(0,0)"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949596",
    transform: "translate(0,0)"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929493",
    transform: "translate(0,0)"
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909190",
    transform: "translate(0,0)"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9D",
    transform: "translate(0,0)"
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9E",
    transform: "translate(0,0)"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928E",
    transform: "translate(0,0)"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8F8E",
    transform: "translate(0,0)"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909190",
    transform: "translate(0,0)"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949694",
    transform: "translate(0,0)"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989998",
    transform: "translate(0,0)"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929593",
    transform: "translate(0,0)"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A4",
    transform: "translate(0,0)"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9B",
    transform: "translate(0,0)"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999998",
    transform: "translate(0,0)"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929495",
    transform: "translate(0,0)"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939393",
    transform: "translate(0,0)"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939293",
    transform: "translate(0,0)"
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929190",
    transform: "translate(0,0)"
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939493",
    transform: "translate(0,0)"
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939794",
    transform: "translate(0,0)"
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969698",
    transform: "translate(0,0)"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A5",
    transform: "translate(0,0)"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919393",
    transform: "translate(0,0)"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909492",
    transform: "translate(0,0)"
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909291",
    transform: "translate(0,0)"
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A4",
    transform: "translate(0,0)"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A3",
    transform: "translate(0,0)"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A5",
    transform: "translate(0,0)"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A0A1",
    transform: "translate(0,0)"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A3",
    transform: "translate(0,0)"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A0",
    transform: "translate(0,0)"
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9E",
    transform: "translate(0,0)"
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9C",
    transform: "translate(0,0)"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9C",
    transform: "translate(0,0)"
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999A",
    transform: "translate(0,0)"
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959596",
    transform: "translate(0,0)"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919293",
    transform: "translate(0,0)"
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909191",
    transform: "translate(0,0)"
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909090",
    transform: "translate(0,0)"
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9290",
    transform: "translate(0,0)"
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909392",
    transform: "translate(0,0)"
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949596",
    transform: "translate(0,0)"
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A4A4",
    transform: "translate(0,0)"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A3",
    transform: "translate(0,0)"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919593",
    transform: "translate(0,0)"
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919592",
    transform: "translate(0,0)"
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909292",
    transform: "translate(0,0)"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929390",
    transform: "translate(0,0)"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908F",
    transform: "translate(0,0)"
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91908F",
    transform: "translate(0,0)"
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909290",
    transform: "translate(0,0)"
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A3",
    transform: "translate(0,0)"
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A7",
    transform: "translate(0,0)"
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959795",
    transform: "translate(0,0)"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A6A4",
    transform: "translate(0,0)"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA2A2",
    transform: "translate(0,0)"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9B",
    transform: "translate(0,0)"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959899",
    transform: "translate(0,0)"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939796",
    transform: "translate(0,0)"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919192",
    transform: "translate(0,0)"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939390",
    transform: "translate(0,0)"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909491",
    transform: "translate(0,0)"
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949494",
    transform: "translate(0,0)"
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939796",
    transform: "translate(0,0)"
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9492",
    transform: "translate(0,0)"
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909491",
    transform: "translate(0,0)"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909192",
    transform: "translate(0,0)"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9F",
    transform: "translate(0,0)"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9E",
    transform: "translate(0,0)"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A2",
    transform: "translate(0,0)"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9DA0",
    transform: "translate(0,0)"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9E",
    transform: "translate(0,0)"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9D",
    transform: "translate(0,0)"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9A",
    transform: "translate(0,0)"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C9C",
    transform: "translate(0,0)"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919394",
    transform: "translate(0,0)"
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B99",
    transform: "translate(0,0)"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9C",
    transform: "translate(0,0)"
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A4",
    transform: "translate(0,0)"
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A5",
    transform: "translate(0,0)"
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9E",
    transform: "translate(0,0)"
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9F",
    transform: "translate(0,0)"
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9C",
    transform: "translate(0,0)"
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959996",
    transform: "translate(0,0)"
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929594",
    transform: "translate(0,0)"
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929490",
    transform: "translate(0,0)"
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919491",
    transform: "translate(0,0)"
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A2A3",
    transform: "translate(0,0)"
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9A",
    transform: "translate(0,0)"
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919492",
    transform: "translate(0,0)"
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A3A3",
    transform: "translate(0,0)"
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA0A2",
    transform: "translate(0,0)"
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9C",
    transform: "translate(0,0)"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9D",
    transform: "translate(0,0)"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A9A",
    transform: "translate(0,0)"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939694",
    transform: "translate(0,0)"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919291",
    transform: "translate(0,0)"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939392",
    transform: "translate(0,0)"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919593",
    transform: "translate(0,0)"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929494",
    transform: "translate(0,0)"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949797",
    transform: "translate(0,0)"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969A99",
    transform: "translate(0,0)"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A0",
    transform: "translate(0,0)"
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A1A6",
    transform: "translate(0,0)"
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919394",
    transform: "translate(0,0)"
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919392",
    transform: "translate(0,0)"
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939595",
    transform: "translate(0,0)"
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9F",
    transform: "translate(0,0)"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A5",
    transform: "translate(0,0)"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A6",
    transform: "translate(0,0)"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9EA0",
    transform: "translate(0,0)"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969898",
    transform: "translate(0,0)"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929492",
    transform: "translate(0,0)"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929692",
    transform: "translate(0,0)"
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A3",
    transform: "translate(0,0)"
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A4",
    transform: "translate(0,0)"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A4",
    transform: "translate(0,0)"
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A6A6",
    transform: "translate(0,0)"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A3A4",
    transform: "translate(0,0)"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA2A1",
    transform: "translate(0,0)"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A2",
    transform: "translate(0,0)"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E9D",
    transform: "translate(0,0)"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9F",
    transform: "translate(0,0)"
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989C9B",
    transform: "translate(0,0)"
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9C",
    transform: "translate(0,0)"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949899",
    transform: "translate(0,0)"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949998",
    transform: "translate(0,0)"
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B9A",
    transform: "translate(0,0)"
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A6A5",
    transform: "translate(0,0)"
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9D",
    transform: "translate(0,0)"
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A3A5",
    transform: "translate(0,0)"
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A98",
    transform: "translate(0,0)"
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949696",
    transform: "translate(0,0)"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A5",
    transform: "translate(0,0)"
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A4",
    transform: "translate(0,0)"
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9F",
    transform: "translate(0,0)"
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9E",
    transform: "translate(0,0)"
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9D",
    transform: "translate(0,0)"
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929495",
    transform: "translate(0,0)"
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939492",
    transform: "translate(0,0)"
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939493",
    transform: "translate(0,0)"
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939593",
    transform: "translate(0,0)"
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949596",
    transform: "translate(0,0)"
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979899",
    transform: "translate(0,0)"
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A6",
    transform: "translate(0,0)"
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A4",
    transform: "translate(0,0)"
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A5A5",
    transform: "translate(0,0)"
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9E",
    transform: "translate(0,0)"
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D9B",
    transform: "translate(0,0)"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9A",
    transform: "translate(0,0)"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959999",
    transform: "translate(0,0)"
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939695",
    transform: "translate(0,0)"
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A6",
    transform: "translate(0,0)"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A6A4",
    transform: "translate(0,0)"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A6A6",
    transform: "translate(0,0)"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F9E",
    transform: "translate(0,0)"
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979997",
    transform: "translate(0,0)"
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959895",
    transform: "translate(0,0)"
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939393",
    transform: "translate(0,0)"
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929596",
    transform: "translate(0,0)"
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939695",
    transform: "translate(0,0)"
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#98999A",
    transform: "translate(0,0)"
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939494",
    transform: "translate(0,0)"
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B99",
    transform: "translate(0,0)"
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A4A3",
    transform: "translate(0,0)"
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A5",
    transform: "translate(0,0)"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A0",
    transform: "translate(0,0)"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9FA0",
    transform: "translate(0,0)"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9FA0",
    transform: "translate(0,0)"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9F",
    transform: "translate(0,0)"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9F",
    transform: "translate(0,0)"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99999C",
    transform: "translate(0,0)"
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9B",
    transform: "translate(0,0)"
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#97999B",
    transform: "translate(0,0)"
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A5",
    transform: "translate(0,0)"
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939393",
    transform: "translate(0,0)"
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9EA0",
    transform: "translate(0,0)"
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989E9C",
    transform: "translate(0,0)"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B9B",
    transform: "translate(0,0)"
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9C",
    transform: "translate(0,0)"
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939894",
    transform: "translate(0,0)"
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949796",
    transform: "translate(0,0)"
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979998",
    transform: "translate(0,0)"
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A1A5",
    transform: "translate(0,0)"
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A6A7",
    transform: "translate(0,0)"
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9E",
    transform: "translate(0,0)"
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A6A4",
    transform: "translate(0,0)"
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9E",
    transform: "translate(0,0)"
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9D",
    transform: "translate(0,0)"
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9B",
    transform: "translate(0,0)"
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959797",
    transform: "translate(0,0)"
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939697",
    transform: "translate(0,0)"
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939795",
    transform: "translate(0,0)"
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969896",
    transform: "translate(0,0)"
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95999A",
    transform: "translate(0,0)"
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA0A1",
    transform: "translate(0,0)"
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969999",
    transform: "translate(0,0)"
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA1A1",
    transform: "translate(0,0)"
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A6",
    transform: "translate(0,0)"
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A6",
    transform: "translate(0,0)"
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9FA1",
    transform: "translate(0,0)"
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949695",
    transform: "translate(0,0)"
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939695",
    transform: "translate(0,0)"
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949596",
    transform: "translate(0,0)"
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A4",
    transform: "translate(0,0)"
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A6",
    transform: "translate(0,0)"
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A5A4",
    transform: "translate(0,0)"
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A1",
    transform: "translate(0,0)"
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9B",
    transform: "translate(0,0)"
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B9B",
    transform: "translate(0,0)"
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959697",
    transform: "translate(0,0)"
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939596",
    transform: "translate(0,0)"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949594",
    transform: "translate(0,0)"
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959695",
    transform: "translate(0,0)"
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979999",
    transform: "translate(0,0)"
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9A",
    transform: "translate(0,0)"
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9F",
    transform: "translate(0,0)"
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949899",
    transform: "translate(0,0)"
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A9A",
    transform: "translate(0,0)"
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A5",
    transform: "translate(0,0)"
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA0A2",
    transform: "translate(0,0)"
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E9D",
    transform: "translate(0,0)"
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D9C",
    transform: "translate(0,0)"
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9C",
    transform: "translate(0,0)"
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979695",
    transform: "translate(0,0)"
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939495",
    transform: "translate(0,0)"
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959897",
    transform: "translate(0,0)"
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A4A5",
    transform: "translate(0,0)"
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A3A4",
    transform: "translate(0,0)"
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A2A2",
    transform: "translate(0,0)"
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA09E",
    transform: "translate(0,0)"
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA0A0",
    transform: "translate(0,0)"
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9F",
    transform: "translate(0,0)"
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9C",
    transform: "translate(0,0)"
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C9D",
    transform: "translate(0,0)"
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969595",
    transform: "translate(0,0)"
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979697",
    transform: "translate(0,0)"
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969899",
    transform: "translate(0,0)"
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969997",
    transform: "translate(0,0)"
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979898",
    transform: "translate(0,0)"
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A9A",
    transform: "translate(0,0)"
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D9C",
    transform: "translate(0,0)"
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A4A4",
    transform: "translate(0,0)"
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A6A8",
    transform: "translate(0,0)"
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A7A6",
    transform: "translate(0,0)"
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949896",
    transform: "translate(0,0)"
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96999A",
    transform: "translate(0,0)"
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A5A5",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.800166445b59e71ad1be5e5b840e1458.svg";
export { ForwardRef as ReactComponent };